(function () {
'use strict';
var dlT = function (k, f) { var d = window.DL_I18N; return (d && d[k] != null) ? d[k] : f; };
/* ═══════════════════════════════════════════════════════════════════════════════
   De Leville · LILLO — the two sizes + the engraving, version B (decided 18 Sep 2026).
   Markup: snippets/dl-lillo-b.liquid. Styles: assets/dl-lillo-b.css.
   Engraving engine: assets/dl-engrave-runtime.js (window.DeLevilleEngraver).

   This file is only the face. The theme's own controls (the two size selectors,
   "I don't know their size yet", the engraving field) stay in the page, hidden, and
   Add to Bag keeps reading them: every choice made here is pushed into them. If this
   file fails, .dlb-on is never set and the theme's own controls simply show.
   ═══════════════════════════════════════════════════════════════════════════════ */
const DESK = matchMedia('(min-width: 1025px)'), desk = () => DESK.matches;
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const US = []; for (let u = 4; u <= 13; u += 0.5) US.push(u);
// EU ring size comes from the maison's own Ring Sizing Guide (/pages/sizing-guide), which is a
// hand-made table: no rounding rule reproduces it. Floor disagreed with it at US 6, 7.5, 9.5 and
// 11, and floor(11.5) = 65 collided with the guide's US 11 = 65, so EU 65 meant two different
// fingers. Above US 11 the guide is unpublished; those four continue its own sequence.
// Never compute a ring size from a formula. See SITE-HUMAN-AUDIT.md section 17.
const EU_GUIDE = { 4:46, 4.5:48, 5:49, 5.5:50, 6:52, 6.5:53, 7:54, 7.5:56, 8:57, 8.5:58,
                   9:59, 9.5:61, 10:62, 10.5:63, 11:65, 11.5:66, 12:67, 12.5:69, 13:70 };
const euOf = us => EU_GUIDE[us] !== undefined ? EU_GUIDE[us] : Math.round(46.8 + 2.555 * (us - 4));
const half = us => Number.isInteger(us) ? String(us) : `${Math.floor(us)}½`;
/* The inside diameter of each size, in mm, copied from the maison's Ring Sizing Guide (never computed). It only scales
   the turning half, so the ring grows under the thumb with the size (Eliau, 29 Sep: "when you go up in size the ring
   become bigger and down smaller").
   ⚠️ The guide stops at US 11. The four above it continue its own +0.4 mm step and are NOT
   confirmed against the real size stick (CLAUDE.md); they are used here only to scale a picture,
   never shown to a customer and never put in an order. */
const DIA_GUIDE = { 4:14.9, 4.5:15.3, 5:15.7, 5.5:16.1, 6:16.5, 6.5:16.9, 7:17.3, 7.5:17.7,
                    8:18.1, 8.5:18.5, 9:18.9, 9.5:19.4, 10:19.8, 10.5:20.2, 11:20.6,
                    11.5:21.0, 12:21.4, 12.5:21.8, 13:22.2 };
const DIA_MAX = DIA_GUIDE[13];
/* ⛔ The wheel's position is continuous, so this reads BETWEEN two published rows. The tween is a drawing, not a size. */
const diaAt = y => {
  const c = Math.min(Math.max(y, 0), US.length - 1), i = Math.floor(c), f = c - i;
  const a = DIA_GUIDE[US[i]], b = DIA_GUIDE[US[Math.min(i + 1, US.length - 1)]];
  return a + (b - a) * f;
};
const KEY = 'dl.lillo.b';
const readS = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
const writeS = o => { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
const $ = (s, r) => (r || document).querySelector(s), $$ = (s, r) => [...(r || document).querySelectorAll(s)];
const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

// a key press shows focus rings; a touch or a click hides them
addEventListener('keydown', e => { if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) document.documentElement.classList.add('dlb-kbd'); }, true);
addEventListener('pointerdown', () => document.documentElement.classList.remove('dlb-kbd'), true);

/* The engraving data, fetched once per CAMERA. A Style switch can move to the other camera
   (Essenza/Regale <-> Puro/Segreto); a single cache for the page once cut a Regale with Puro's
   numbers: the name landed on the pavé and the plate sat a seam off (Eliau, 18 Sep). */
const dataP = {};
const getData = url => dataP[url] || (dataP[url] = fetch(url).then(r => r.json()));
const loadImg = url => new Promise(res => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = () => res(null); i.src = url; });

let inst = null;
function boot() {
  const root = $('[data-dlb]');
  if (!root) {                                            // switched to a product without it: the theme's controls come back
    if (inst) { inst.destroy(); inst = null; }
    $$('.dlb-on').forEach(n => n.classList.remove('dlb-on'));
    return;
  }
  if (inst && inst.root === root) return;
  if (inst) inst.destroy();
  try { inst = make(root); } catch (e) { inst = null; console.warn('LILLO sizes and engraving: the theme controls stay', e); }
}
window.DLLilloB = {
  /* called by snc-sections.js when Add to Bag finds something missing: true = handled here */
  flag(kind, slot) { return !!(inst && inst.flag(kind, slot)); },
  /* read-only, for tests: which camera this page cuts with, and whether the round photo carries the name */
  state() { return inst ? inst.state() : null; },
  /* 13 Oct: read by snc-sections.js when it builds the order. 'two' (the exchange) or 'one' (only you wear it) */
  who() { return inst ? inst.who() : ''; },
  /* the partner's ring, when "Choose theirs too" is on: more /cart/add.js items, or [] */
  extraItems(sz) { return inst ? inst.extraItems(sz) : []; },
  /* arriving from a pair link: who sent it and what they chose, for the order */
  pairWith() { return inst ? inst.pairWith() : ''; },
};
/* Start after the theme: snc-sections.js wires the size buttons at DOMContentLoaded, and this
   deferred file runs just before that. A restored size clicked before then selects nothing. */
if (document.readyState === 'complete') boot();
else {
  document.addEventListener('DOMContentLoaded', () => setTimeout(boot, 0), { once: true });
  addEventListener('load', boot, { once: true });                 // if this file ever runs after DOMContentLoaded
}
// a Style switch replaces the product in place: start again on the new markup, after the
// theme has replayed the choices into its own controls
document.addEventListener('snc:pdp:swapped', () => setTimeout(boot, 0));

function make(root) {
  const cfg = JSON.parse($('[data-dlb-config]', root).textContent);
  /* strings this file needs that the shared DL_I18N list does not carry (13 Oct: "Choose your sizes" went back to
     English in 13 languages the moment the folded card re-rendered, because lillo.choose_sizes was never in it) */
  const tt = (k, f) => (cfg.t && cfg.t[k]) || dlT('lillo.' + k, f);
  const hero = root.closest('[data-section-type="snc-pdp-hero"]') || document;
  const group = root.closest('[data-size-group]') || root.parentNode;
  const off = [];
  const listen = (t, ev, fn, o) => { t.addEventListener(ev, fn, o); off.push(() => t.removeEventListener(ev, fn, o)); };

  /* ── state: this tab's choices, pushed into the theme's controls ───────────── */
  const saved = readS();
  const legacyUS = slot => { const p = $(`[data-size-selector][data-slot="${slot}"] .pdp-hero--size-pill.is-selected`, hero); return p ? parseFloat(p.dataset.us) : null; };
  const unk = $('[data-size-unknown]', hero), legacyEng = $('[data-engrave]', hero), e2Hidden = $('[data-engrave-2]', root);
  const st = {
    yours: legacyUS('yours') != null ? legacyUS('yours') : (saved.yours != null ? saved.yours : null),
    theirs: legacyUS('theirs') != null ? legacyUS('theirs') : (saved.theirs != null ? saved.theirs : null),
    later: false, unit: saved.unit === 'EU' ? 'EU' : 'US',
    e1: (legacyEng && legacyEng.value.trim()) || saved.e1 || '', e2: saved.e2 || '',
  };
  st.later = (unk && unk.checked) || (!!saved.later && st.theirs == null);
  /* Eliau, 11 Oct: One name (the same on both rings) or Two names (one on each, the first on your ring) */
  st.two = !!st.e2 || !!saved.two;
  /* 15 Oct, option A: in the exchange each half has its own name field (empty = the same name as yours) */
  if (saved.two === undefined && saved.who !== 'one') st.two = true;
  /* 13 Oct, Eliau: who will wear it. 'two' = the exchange (each wears one, a half from each), 'one' = only you, both
     halves in your size. oh = the half they give you: '' | 'here' (their ring in this bag too) | 'link' (a pair link) */
  st.who = saved.who === 'one' ? 'one' : 'two';
  st.oh = saved.oh === 'here' || saved.oh === 'link' ? saved.oh : '';
  st.pt = saved.pt || cfg.other; st.me = saved.me || ''; st.to = saved.to || ''; st.note = saved.note || '';
  if (!cfg.rings[st.pt]) st.pt = cfg.rings[cfg.other] ? cfg.other : cfg.piece;
  let keepT = saved.keepT || null;                      // their size, kept while only you wear it
  /* Eliau, 11 Oct: "when somebody press on engraving, it opens up to these options". Folded until tapped. */
  let enOpen = false;
  /* 14 Oct: one question at a time. whoOpen = the two tiles show (else they are the card's first line); ohOpen = their
     half is opened; enAuto = the names have already opened by themselves once (never again after they are closed). */
  let flowReady = false, whoOpen = true, ohOpen = false, enAuto = false;
  const save = () => writeS({ yours: st.yours, theirs: st.theirs, later: st.later, unit: st.unit, e1: st.e1, e2: st.e2, two: st.two,
    who: st.who, oh: st.oh, pt: st.pt, me: st.me, to: st.to, note: st.note, keepT });
  const one = () => st.who === 'one';
  /* only you wear it: their wheel follows yours (both halves in your size), so it is set the moment yours is */
  const unset = s => (s === 'theirs' && one()) ? st.yours == null : (st[s] == null && !(s === 'theirs' && st.later));
  const show = us => st.unit === 'EU' ? `EU ${euOf(us)}` : `US ${half(us)}`;
  const sizeNum = us => st.unit === 'EU' ? String(euOf(us)) : half(us);

  function selectPill(w, p) {
    p.click();                                            // the theme's own handler: label, aria, errors
    if (p.classList.contains('is-selected')) return;
    // not wired (yet): set exactly what that handler sets, which is what Add to Bag reads
    $$('.pdp-hero--size-pill', w).forEach(x => { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
    p.classList.add('is-selected'); p.setAttribute('aria-checked', 'true');
    const val = `US ${p.dataset.us} / EU ${p.dataset.eu}`;
    const i = $('[data-ring-size]', w); if (i) i.value = val;
    const tl = $('[data-size-trigger-label]', w); if (tl) tl.textContent = val;
    const tr = $('[data-size-trigger]', w); if (tr) tr.classList.remove('is-placeholder');
  }
  const slotValue = slot => { const i = $(`[data-size-selector][data-slot="${slot}"] [data-ring-size]`, hero); return i ? i.value : ''; };
  const legacyReady = () => !!slotValue('yours') && (!!slotValue('theirs') || !!(unk && unk.checked));
  function pushSizes() {
    if (one()) { st.theirs = st.yours; st.later = false; }
    ['yours', 'theirs'].forEach(slot => {
      const w = $(`[data-size-selector][data-slot="${slot}"]`, hero); if (!w) return;
      const v = st[slot];
      if (v != null && (legacyUS(slot) !== v || !slotValue(slot))) { const p = $(`.pdp-hero--size-pill[data-us="${v}"]`, w); if (p) selectPill(w, p); }
      if (v == null && legacyUS(slot) != null) {
        const i = $('[data-ring-size]', w); if (i) i.value = '';
        $$('.pdp-hero--size-pill', w).forEach(p => { p.classList.remove('is-selected'); p.setAttribute('aria-checked', 'false'); });
      }
      w.classList.remove('has-error', 'is-pulsing');
    });
    if (unk && unk.checked !== st.later) { unk.checked = st.later; unk.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('[data-size-panel].is-open', hero).forEach(p => { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    $$('[data-size-trigger][aria-expanded="true"]', hero).forEach(t => t.setAttribute('aria-expanded', 'false'));
  }
  function pushEngraving() {
    if (legacyEng && legacyEng.value !== st.e1) { legacyEng.value = st.e1; legacyEng.dispatchEvent(new Event('input', { bubbles: true })); }
    const f = $('[data-engrave-field]', hero); if (f && st.e1) f.classList.remove('has-error', 'is-pulsing');
    if (e2Hidden) e2Hidden.value = st.e2;
  }

  /* ── the pop-up and the sheet live on <body> (a transformed ancestor would clip them) ── */
  $$('body > [data-dlb-pop], body > [data-dlb-sheet]').forEach(n => n.remove());
  const pop = $('[data-dlb-pop]', root), sheet = $('[data-dlb-sheet]', root);
  document.body.appendChild(pop); document.body.appendChild(sheet);
  const sizerEl = $('[data-dlb-sizer]', root), fieldsEl = $('[data-dlb-fields]', root);
  const camEl = $('[data-dlb-cam]', sheet), stage = $('[data-dlb-stage]', sheet), bar = $('[data-dlb-bar]', sheet);
  const fullEl = $('[data-dlb-full]', sheet), camNone = $('[data-dlb-cam-none]', sheet), loupe = $('[data-dlb-loupe]', sheet);
  const eng1 = $('#dlb-eng1', fieldsEl), eng2 = $('#dlb-eng2', fieldsEl), f2 = $('[data-dlb-f2]', fieldsEl);
  const szSec = $('[data-dlb-sz]', root), enSec = $('[data-dlb-en]', root);
  /* 11 Oct (2): folded, the sizes are the sizer itself, small (the "wheel peek", option 4 of the folded looks):
     your half, the two wheels, their half, always on the page and working. No door, no Done: a size is chosen the
     moment its wheel or its half comes to rest. "Not sure of your size?" and US/EU move up beside "Two sizes". */
  const PEEK = true;
  if (PEEK) { szSec.classList.add('is-peek'); $('.dlb-head', szSec).appendChild($('.dlb-foot', sizerEl)); }
  /* 12 Oct, Eliau: "what about sizes? show it to me folded". Folded, the sizes are a card like the engraving's; a tap
     opens the wheels; once both sizes are set the card folds itself back (his 25 Sep ask: "when you choose your size
     on both sides, they close"). Nothing moves the halves together: two fingers, two rings (30 Sep). */
  const fold = $('[data-dlb-sz-fold]', root);
  $$('[data-dlb-sh]', root).forEach(img => { img.src = cfg.halves[img.dataset.dlbSh]; });
  if (!cfg.hasPlate) {
    /* No engraving picture here, so no arc to measure against: keep the theme's old limit
       (16 characters) and the letters the engraver can cut (the same set the runtime allows). */
    [eng1, eng2].forEach(inp => {
      inp.maxLength = 16;
      inp.addEventListener('input', () => { const v = inp.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 '’.\-&·]/g, ''); if (v !== inp.value) inp.value = v; });
    });
  }
  [pop, sheet, sizerEl].forEach(n => n.setAttribute('data-lenis-prevent', ''));   // Lenis: scroll these natively
  $$('[data-dlb-half-img]', sizerEl).forEach(img => { img.src = cfg.halves[img.dataset.dlbHalfImg]; });
  group.classList.add('dlb-on');

  /* ── the sizes on the page ─────────────────────────────────────────────────── */
  let editing = false;
  function renderRow() {
    const any = !unset('yours') || !unset('theirs'), open = editing;
    szSec.classList.toggle('is-editing', open);
    $('[data-dlb-sz-inline]', root).hidden = !open;
    $('[data-dlb-sz-open]', root).hidden = any || open;
    $('[data-dlb-sz-chosen]', root).hidden = !any || open;
    $('[data-dlb-sz-change]', root).hidden = !any || open;
    const y = $('[data-dlb-sz-y]', root), t = $('[data-dlb-sz-t]', root);
    y.textContent = st.yours != null ? show(st.yours) : dlT('lillo.choose', 'Choose'); y.classList.toggle('is-quiet', st.yours == null);
    t.textContent = st.theirs != null ? show(st.theirs) : st.later ? dlT('lillo.to_follow', 'To follow') : dlT('lillo.choose', 'Choose'); t.classList.toggle('is-quiet', st.theirs == null);
    if (PEEK && fold) {
      ['[data-dlb-sz-open]', '[data-dlb-sz-chosen]', '[data-dlb-sz-change]'].forEach(q => { $(q, root).hidden = true; });
      fold.hidden = open; fold.setAttribute('aria-expanded', String(open));
      const ft = $('[data-dlb-sz-ft]', fold), fs = $('[data-dlb-sz-fs]', fold);
      if (!any) { ft.textContent = one() ? tt('your_size', 'Your size') : tt('choose_sizes', 'Choose your sizes'); fs.textContent = one() ? fs.dataset.noteOne : fs.dataset.note; }
      else {
        /* "US 9 · US 12½" over "Yours · Theirs"; Futura has no middot, so the dot is drawn in Arial */
        const dot = () => { const d = document.createElement('span'); d.className = 'dlb-dot'; d.textContent = ' · '; return d; };
        if (one()) { ft.replaceChildren(y.textContent); fs.textContent = fs.dataset.noteOne; }
        else {
          ft.replaceChildren(y.textContent, dot(), t.textContent);
          fs.replaceChildren(dlT('lillo.yours', 'Yours'), dot(), st.later ? dlT('lillo.theirs_later', 'Theirs, later') : dlT('lillo.theirs', 'Theirs'));
        }
      }
      $('[data-dlb-sz-fchev]', fold).style.display = any ? 'none' : '';
      $('[data-dlb-sz-fch]', fold).hidden = !any;
    }
    renderFlow();
  }

  /* ── the sizer: your half, the two wheels, their half ──────────────────────── */
  const WH = {};
  ['yours', 'theirs'].forEach(slot => {
    const strip = $(`[data-dlb-strip="${slot}"]`, sizerEl), range = $(`[data-dlb-range="${slot}"]`, sizerEl);
    const w = { strip, range, rows: [], expect: null, user: false, touching: false, t: 0, raf: 0 };
    w.rows = US.map((us, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'dlb-r'; b.tabIndex = -1; b.innerHTML = '<span></span>';
      b.addEventListener('click', () => tapRow(slot, i)); strip.appendChild(b); return b;
    });
    /* `expect` is where WE are scrolling the wheel to: a scroll we cause (even an instant
       one) fires its scroll event later, and must never read as a finger choosing a size */
    strip.addEventListener('scroll', () => {
      if (w.expect == null) w.user = true;
      if (!w.raf) w.raf = requestAnimationFrame(() => paint(slot));
      clearTimeout(w.t); w.t = setTimeout(() => settle(slot), 140);
    }, { passive: true });
    const hold = () => { w.touching = true; w.expect = null; };
    const lift = () => { if (!w.touching) return; w.touching = false; clearTimeout(w.t); w.t = setTimeout(() => settle(slot), 160); };
    strip.addEventListener('pointerdown', hold); strip.addEventListener('touchstart', hold, { passive: true });
    strip.addEventListener('touchend', lift, { passive: true }); listen(window, 'pointerup', lift);
    /* A mouse wheel or a trackpad moves the wheel one row per step. Handled here because the
       product section turns every wheel inside it into column scrolling (and Lenis would
       scroll the page): one notch is one size, a trackpad row is its own height. */
    let acc = 0, accT = 0;
    strip.addEventListener('wheel', e => {
      if (e.ctrlKey || Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      e.preventDefault();
      acc += e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * strip.clientHeight : e.deltaY;
      clearTimeout(accT); accT = setTimeout(() => { acc = 0; }, 180);
      if (Math.abs(acc) < rowH(slot) * 0.8) return;
      const from = w.expect != null ? Math.round(w.expect / rowH(slot)) : idxOf(slot);
      const to = Math.max(0, Math.min(US.length - 1, from + Math.sign(acc))); acc = 0;
      if (to !== from || unset(slot)) tapRow(slot, to);
    }, { passive: false });
    range.addEventListener('input', () => { pick(slot, US[+range.value]); place(slot, true); });
    WH[slot] = w;
  });
  const rowH = slot => WH[slot].rows[0].offsetHeight || 36;
  const idxOf = slot => Math.max(0, Math.min(US.length - 1, Math.round(WH[slot].strip.scrollTop / rowH(slot))));

  /* ── the half turns with its wheel (from the 25-29 Sep turntable draft 157465378953) ─────────────────
     Eliau, 25 Sep: "when you scroll up down in each size you actually are scrolling also the ring up down", and
     11 Oct: "the half rings rotating when you swipe up and down". Each sheet is 40 renders of one half turned
     about its own finger axis: one period of the band, so it plays round.
     ⛔ The frame comes from the wheel's CONTINUOUS position, never from the chosen size, or the ring steps once
     per row and loses the thing he asked for.
     ⛔ Moving, two neighbours are cross-faded; at rest it snaps to ONE frame (a blend held still is a double
     image: 27 of 255 off the true picture between them). settle() repaints for exactly that reason. */
  const SPIN = cfg.spin || null, SPIN_KEY = { yours: 'top', theirs: 'bottom' }, sheets = {};
  let spinAsked = false;
  function wantSpin() {
    if (!SPIN || spinAsked) return; spinAsked = true;
    Object.keys(SPIN_KEY).forEach(slot => {
      const im = new Image(); im.decoding = 'async';
      im.onload = () => { sheets[slot] = im; $(`[data-dlb-half="${slot}"]`, sizerEl).classList.add('has-spin'); paintSpin(slot); };
      im.src = SPIN[SPIN_KEY[slot]];
    });
  }
  function paintSpin(slot, at) {
    const im = sheets[slot]; if (!im) return;
    const cv = $(`[data-dlb-spin="${slot}"]`, sizerEl), box = cv.getBoundingClientRect();
    if (!box.width) return;
    const dpr = Math.min(devicePixelRatio || 1, 2), W = Math.round(box.width * dpr), H = Math.round(box.height * dpr);
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    const cols = SPIN.cols, n = SPIN.frames, fw = im.width / cols, fh = im.height / Math.ceil(n / cols);
    const src = one() ? 'yours' : slot;                  // only you: both halves are your size, both follow your wheel
    const y = at != null ? at : WH[src].strip.scrollTop / rowH(src);
    const w = WH[src], live = w.touching || w.user;
    let t = y * (SPIN.perSize || (n - 1) / (US.length - 1));
    if (!live) t = Math.round(t);
    const k0 = ((Math.floor(t) % n) + n) % n, k1 = (k0 + 1) % n, mix = t - Math.floor(t);
    /* contained with air, then scaled by the finger: US 13 fills the box, US 4 draws at 14.9/22.2 of it */
    const s = Math.min(W / fw, H / fh) * 0.97 * (diaAt(y) / DIA_MAX), dw = fw * s, dh = fh * s;
    const c = cv.getContext('2d'); c.clearRect(0, 0, W, H);
    const put = (k, a) => {
      if (a <= 0.002) return;
      c.globalAlpha = a;
      c.drawImage(im, (k % cols) * fw, Math.floor(k / cols) * fh, fw, fh, (W - dw) / 2, (H - dh) / 2, dw, dh);
    };
    put(k0, 1); put(k1, mix); c.globalAlpha = 1;
  }
  /* the sheets are asked for when the sizer comes near the screen, not before */
  if (SPIN && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); wantSpin(); } }, { rootMargin: '200px' });
    io.observe(sizerEl); off.push(() => io.disconnect());
  }

  /* ── the half is a control: swipe it up or down and its own wheel turns (Eliau, 25 Sep: "when you swipe up or
     down on a ring, the actual number goes up and down"). It writes the wheel's own scrollTop and ends in settle(),
     so a swipe on the ring and a finger on the numbers commit by exactly the same path.
     ⛔ touch-action none, or the browser takes the vertical swipe for the page before the first pointermove.
     ⛔ preventDefault on pointerdown: touch-action does nothing for a mouse, which would select the picture. */
  ['yours', 'theirs'].forEach(slot => {
    const box = $(`[data-dlb-half="${slot}"]`, sizerEl); if (!box) return;
    box.style.touchAction = 'none'; box.style.cursor = 'ns-resize';
    let id = null, fromY = 0, fromTop = 0, moved = false;
    const drv = () => one() ? 'yours' : slot;            // only you: either half turns your one wheel
    box.addEventListener('pointerdown', e => {
      const w = WH[drv()];
      id = e.pointerId; fromY = e.clientY; fromTop = w.strip.scrollTop; moved = false;
      w.touching = true; w.expect = null;
      e.preventDefault();
      try { box.setPointerCapture(id); } catch (err) {}
    });
    box.addEventListener('pointermove', e => {
      if (id !== e.pointerId) return;
      const w = WH[drv()], dy = e.clientY - fromY;
      if (!moved && Math.abs(dy) < 3) return;
      moved = true; w.user = true;
      const max = (US.length - 1) * rowH(slot);
      w.strip.scrollTop = Math.max(0, Math.min(max, fromTop - dy));   // the ring up, the number up
      if (!w.raf) w.raf = requestAnimationFrame(() => paint(drv()));   // one repaint a frame, not one per move
    });
    const lift = e => {
      if (id !== e.pointerId) return;
      id = null; const d = drv(), w = WH[d]; w.touching = false;
      if (moved) settle(d); else { w.user = false; place(d, true); }   // a tap chooses nothing
      try { box.releasePointerCapture(e.pointerId); } catch (err) {}
    };
    box.addEventListener('pointerup', lift);
    box.addEventListener('pointercancel', lift);
  });
  function paint(slot) {
    const w = WH[slot]; w.raf = 0;
    const y = w.strip.scrollTop / rowH(slot), quiet = unset(slot) && !w.user && !w.touching;   // nothing chosen: the wheel waits, flat
    w.rows.forEach((r, i) => {
      const k = quiet ? 0 : Math.max(0, 1 - Math.abs(i - y));
      r.firstChild.style.transform = k > 0.001 ? `scale(${(1 + 0.42 * k).toFixed(3)})` : '';
      r.firstChild.style.color = k > 0.5 ? '#111' : '';
    });
    paintSpin(slot, y);
    if (one() && slot === 'yours') paintSpin('theirs', y);
  }
  function place(slot, smooth) {
    const w = WH[slot]; if (w.touching || w.user) return;
    const top = US.indexOf(st[slot] != null ? st[slot] : 7) * rowH(slot);
    if (Math.abs(w.strip.scrollTop - top) < 1) { paint(slot); return; }
    w.expect = top; w.strip.scrollTo({ top, behavior: smooth && !RM ? 'smooth' : 'auto' }); paint(slot);
  }
  function settle(slot) {
    const w = WH[slot]; if (w.touching) return;
    if (w.expect != null) { w.expect = null; paint(slot); return; }
    if (!w.user) return;
    w.user = false; pick(slot, US[idxOf(slot)]);
    paint(slot);                                          // rest on one frame, never on a blend
  }
  function tapRow(slot, i) {
    const w = WH[slot]; w.user = false; w.touching = false; w.expect = i * rowH(slot);
    w.strip.scrollTo({ top: i * rowH(slot), behavior: RM ? 'auto' : 'smooth' });
    pick(slot, US[i]);
  }
  function pick(slot, us) {
    st[slot] = us; if (slot === 'theirs') st.later = false;
    if (one() && slot === 'yours') { st.theirs = us; st.later = false; }
    if (PEEK && !unset('yours') && !unset('theirs')) szSec.classList.remove('is-flag');
    save(); pushSizes(); renderSizer(); renderRow();
  }
  /* the fold, by itself: both sizes set, no finger on a wheel, a breath to see them land. Only when this opening began
     with a size missing; someone who opened to change one size closes with Done. */
  let foldArmed = false, foldT = 0;
  function foldSizes() { clearTimeout(foldT); foldArmed = false; szSec.classList.remove('is-flag'); editing = false; renderRow(); afterSizes(); }
  /* 14 Oct: the sizes are answered, so the question above folds into the card and the names open (once, by themselves,
     without raising a keyboard: the field waits for a tap) */
  function afterSizes() {
    /* 15 Oct (3): the sizes' own Done folds them into one line; the first time, the names open next (no keyboard: the
       field waits for a tap); afterwards it goes back to the summary */
    whoOpen = false; editing = false;
    const toNames = !enAuto; if (toNames) { enAuto = true; enOpen = true; }
    syncFields(); renderRow(); renderEn();
    if (toNames) ensureRings().then(ok => { if (ok) { ringsUpdate(); ringsDraw(); turnIntro(); } });
    requestAnimationFrame(() => (toNames ? enSec : flowEl).scrollIntoView({ block: toNames ? 'start' : 'nearest', behavior: RM ? 'auto' : 'smooth' }));
  }
  /* one Done for the step: both sizes are needed (the names are not), then each half folds to one line */
  function foldStep() {
    if (unset('yours') || unset('theirs')) { renderSizer(true); szSec.classList.add('is-flag'); focusWheel(); return false; }
    liveCommit(); editing = false; enOpen = false; whoOpen = false; szSec.classList.remove('is-flag');
    if (document.activeElement) document.activeElement.blur();
    renderRow(); renderEn(); renderGallery(); ringsFocus(-1);
    requestAnimationFrame(() => flowEl.scrollIntoView({ block: 'nearest', behavior: RM ? 'auto' : 'smooth' }));
    return true;
  }
  /* a half's line reopens the names (the sizes line above has its own Change) */
  function openStep() {
    editing = false; enOpen = true;
    syncFields(); renderRow(); renderEn();
    ensureRings().then(ok => { if (ok) { ringsUpdate(); ringsDraw(); turnIntro(); } });
    requestAnimationFrame(() => enSec.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }));
  }
  function openSizesStep() {
    whoOpen = false; editing = true; enOpen = false;
    renderRow(); renderSizer(); renderEn();
    requestAnimationFrame(() => { place('yours', false); place('theirs', false); szSec.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }); });
  }
  function maybeFold() {
    return;                                                // 15 Oct, option A: the step folds on its one Done, never by itself
    if (!PEEK || !editing || !foldArmed || unset('yours') || unset('theirs')) return;
    clearTimeout(foldT);
    foldT = setTimeout(() => {
      if (!editing || unset('yours') || unset('theirs')) return;
      if (['yours', 'theirs'].some(s => WH[s].touching || WH[s].user)) { maybeFold(); return; }
      foldSizes();
    }, 1100);
  }
  function renderSizer(flag) {
    ['yours', 'theirs'].forEach(slot => {
      const box = $(`[data-dlb-half="${slot}"]`, sizerEl), lab = $(`[data-dlb-lab="${slot}"]`, sizerEl), w = WH[slot];
      box.classList.toggle('is-lit', !unset(slot));
      box.classList.toggle('is-pulse', !!flag && unset(slot));
      lab.classList.toggle('is-set', !unset(slot));
      lab.textContent = slot === 'yours' ? (one() ? tt('your_size', 'Your size') : dlT('lillo.yours', 'Yours')) : st.later ? dlT('lillo.theirs_later', 'Theirs, later') : dlT('lillo.theirs', 'Theirs');
      $(`[data-dlb-vw="${slot}"]`, sizerEl).classList.toggle('is-later', slot === 'theirs' && st.later);
      w.rows.forEach((r, i) => { r.firstChild.textContent = sizeNum(US[i]); });
      w.range.value = String(US.indexOf(st[slot] != null ? st[slot] : 7));
      w.range.setAttribute('aria-valuetext', st[slot] != null ? show(st[slot]) : dlT('lillo.no_size_yet', 'No size yet'));
    });
    $('[data-dlb-duo]', sizerEl).classList.toggle('is-both', !unset('yours') && !unset('theirs'));
    sizerEl.classList.toggle('is-one', one());
    const sw = $('[data-dlb-unit]', root); sw.textContent = st.unit; sw.setAttribute('aria-label', dlT('lillo.unit_switch', 'Sizes in {unit}. Show {other} sizes').replace('{unit}', st.unit).replace('{other}', st.unit === 'US' ? 'EU' : 'US'));
    $('[data-dlb-later]', sizerEl).textContent = st.later ? dlT('lillo.know_their_size', 'I know their size') : dlT('lillo.add_their_size_later', 'Add their size later');
    $('[data-dlb-sz-done]', sizerEl).setAttribute('aria-disabled', String(unset('yours') || unset('theirs')));
    const szh = $('[data-dlb-szhint]', sizerEl);
    if (szh) { szh.hidden = !(unset('yours') || unset('theirs')); szh.textContent = one() ? szh.dataset.one : szh.dataset.two; }
    requestAnimationFrame(() => { place('yours', true); place('theirs', true); });
  }
  const focusWheel = () => WH[unset('yours') ? 'yours' : 'theirs'].range.focus({ preventScroll: true });
  $('[data-dlb-unit]', root).addEventListener('click', () => { st.unit = st.unit === 'US' ? 'EU' : 'US'; save(); renderSizer(); renderRow(); });
  $('[data-dlb-help]', root).addEventListener('click', e => { const b = $('[data-dlb-help-box]', sizerEl); b.hidden = !b.hidden; e.currentTarget.setAttribute('aria-expanded', String(!b.hidden)); });
  $('[data-dlb-later]', sizerEl).addEventListener('click', () => {
    if (st.later) st.later = false; else { st.later = true; st.theirs = null; }
    save(); pushSizes(); renderSizer(); renderRow();
  });

  let popOpener = null;
  function openSizes(slot, flag) {
    popOpener = document.activeElement;
    if (closing) return;
    whoOpen = false; enOpen = false;                       // the bag bar's "Choose your sizes" lands on the sizes step
    openRing();
    if (flag) szSec.classList.add('is-flag');
    foldArmed = unset('yours') || unset('theirs');
    editing = true; renderRow(); renderSizer(flag);
    requestAnimationFrame(() => { place('yours', false); place('theirs', false); if (flag) szSec.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' }); });
    if (flag) setTimeout(focusWheel, 0);
  }
  function closeSizes() {
    szSec.classList.remove('is-flag');
    if (!unset('yours') && !unset('theirs')) editing = false;
    renderRow();
    if (!editing) setTimeout(() => { const b = $('[data-dlb-sz-change]', root); if (b.offsetParent) b.focus({ preventScroll: true }); }, 0);
  }
  /* Done: the two halves slide into each other and interlock, and the ring closes. The designer
     rendered both halves on ONE canvas; there the bottom half's centre sits this far from the top
     half's (a fraction of the picture's width), so at the end the teeth sit exactly in place. The
     top half is drawn over the bottom one, as in the designer's composite. */
  const CLOSE = { essenza: -0.01715, regale: -0.01715, puro: -0.02733, segreto: -0.02733 };
  let closing = false;
  function closeRing(then) {
    const hL = $('[data-dlb-half="yours"]', sizerEl), hR = $('[data-dlb-half="theirs"]', sizerEl);
    if (RM || !hL.offsetWidth) { then(); return; }
    closing = true;
    const rL = hL.getBoundingClientRect(), rR = hR.getBoundingClientRect(), w = $('img', hL).offsetWidth;
    /* right to left the pair is turned half a circle (dl-lillo-b.css), so the designer's offset runs the other way */
    const flip = getComputedStyle(sizerEl).direction === 'rtl' ? -1 : 1;
    const xL = rL.left + rL.width / 2, xR = rR.left + rR.width / 2, m = (xL + xR) / 2, d = (CLOSE[cfg.tier] || 0) * w * flip;
    /* Eliau, 18 Sep: "a little bit slower… end before the last frame". The halves stop at 90% of
       the way: met, teeth interlocked, both rims still reading as two halves, not merged into one. */
    const f = 0.9;
    sizerEl.classList.add('is-closing');
    hL.style.transform = `translateX(${(f * (m - d / 2 - xL)).toFixed(2)}px)`;
    hR.style.transform = `translateX(${(f * (m + d / 2 - xR)).toFixed(2)}px)`;
    setTimeout(() => sizerEl.classList.add('is-closed'), 1260);       // the moment they have met
    setTimeout(() => { closing = false; then(); }, 1800);
  }
  function openRing() {                                     // apart again, instantly, for the next opening
    sizerEl.classList.remove('is-closing', 'is-closed');
    $$('[data-dlb-half]', sizerEl).forEach(h => { h.style.transition = 'none'; h.style.transform = ''; void h.offsetWidth; h.style.transition = ''; });
  }
  $('[data-dlb-sz-done]', sizerEl).addEventListener('click', () => {
    if (closing) return;
    if (unset('yours') || unset('theirs')) { renderSizer(true); focusWheel(); return; }
    if (PEEK) { foldSizes(); return; }                    // the halves stay where they are: two fingers, two rings
    closeRing(() => {
      closeSizes();
      szSec.classList.remove('is-set-anim'); void szSec.offsetWidth; szSec.classList.add('is-set-anim');
    });
  });
  $$('[data-dlb-pop-x]', pop).forEach(x => x.addEventListener('click', closeSizes));
  $('[data-dlb-sz-open]', root).addEventListener('click', () => openSizes());
  if (fold) fold.addEventListener('click', () => openSizes());
  $('[data-dlb-sz-change]', root).addEventListener('click', () => openSizes('yours'));

  /* ── engraving: the cutters (made when first needed) ───────────────────────── */
  let D = null, SP = null, engL = null;
  let CB = [990, 1030, 2640, 2660];                        // the plate's box in the 3500 px render (data.crop2)
  let cutReady = null;
  function ensureCutters() {
    if (cutReady) return cutReady;
    if (!window.DeLevilleEngraver || !cfg.hasPlate) return (cutReady = Promise.resolve(false));
    cutReady = getData(cfg.engraveData).then(d => {
      D = d; SP = d.spaces;
      /* Each FRONT camera has its own plate box (Essenza and Regale one, Puro and Segreto
         another): size both canvases to it before the cutters read their size. */
      if (Array.isArray(d.crop2)) CB = d.crop2;
      const cw = CB[2] - CB[0], ch = CB[3] - CB[1];
      loupe.width = cw; loupe.height = ch;
      Object.assign(loupe.style, { left: CB[0] * U + 'px', top: CB[1] * U + 'px', width: cw * U + 'px', height: ch * U + 'px' });
      const common = { note: null, dataUrl: cfg.engraveData, plateUrl: g => cfg.plates[g].crop, plate: { origin: [CB[0], CB[1]], scale: 1 }, gold: cfg.gold, weight: 500 };
      engL = DeLevilleEngraver(Object.assign({}, common, { loupe: null, canvas: loupe, inputs: [eng1, eng2],
        onChange: ({ shrunk }) => {
          const h = $('[data-dlb-hint1]', fieldsEl); if (h) h.textContent = shrunk ? dlT('lillo.sized_to_fit_band', 'Sized to fit the band.') : '';
          liveCommit(); drawBox();
        } }));
      drawBox();                                          // the bare band, before a letter is typed
      return true;
    }).catch(() => false);
    return cutReady;
  }
  const waitReady = e => new Promise(res => { let n = 0; (function w() { if (e && e.ready && e.ready()) return res(true); if (++n > 240) return res(false); setTimeout(w, 50); })(); });
  function liveCommit() {
    const a = eng1.value.trim(), b = eng2.disabled ? '' : eng2.value.trim();
    if (a !== st.e1 || b !== st.e2) { st.e1 = a; st.e2 = b; save(); pushEngraving(); renderEn(); }
  }
  /* ── the box you engrave in ──────────────────────────────────────────────────
     Eliau, 20 Sep: "the engraver photos should show up only when you press on the engrave,
     and all that engraving should be on a little box where it looks like you are engraving
     something." So nothing shows until the field is touched; then the box opens and it is
     the whole station — the piece under the light and the name being cut into it, live, from
     the same canvas the full-screen view cuts. Of four framings shown side by side he chose
     THE LOUPE: a round window on the band, turned so the name reads straight, wide enough to
     carry the ring's own edges and large enough that the letters are letters. The three that
     lost (bench, plate, ring) are in commit 09b13f4 if they are ever wanted back. */
  const BOX_SPAN = 520;                                   // pixels of the render across the window
  const boxC = $('[data-dlb-box-canvas]', root);
  function drawBox() {
    if (!boxC) return;
    const c = boxC.getContext('2d'), W = boxC.width, H = boxC.height;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.fillStyle = '#efeeeb'; c.fillRect(0, 0, W, H);
    if (!D || !SP || !loupe.width) return;
    const sp = SP[activeF === 1 && !eng2.disabled ? 1 : 0];
    const t = sp.centre * Math.PI / 180;
    const rTop = D.mark.r_top - 8, rBot = D.ink_bot || (D.mark.r_base + 18), rMid = (rTop + rBot) / 2;
    c.translate(W / 2, H / 2);
    c.rotate(Math.PI / 2 - t);                             // turn the arc so the name reads straight
    c.scale(W / BOX_SPAN, W / BOX_SPAN);
    c.translate(-(D.cx + rMid * Math.cos(t)), -(D.cy + rMid * Math.sin(t)));
    c.imageSmoothingQuality = 'high';
    c.drawImage(loupe, CB[0], CB[1]);                      // the loupe holds the plate's box only
    c.setTransform(1, 0, 0, 1, 0, 0);
  }
  /* the box is shut until the name field is touched */
  let cutting = false;
  function setCutting(on) {
    if (cutting === on) return;
    cutting = on;
    enSec.classList.toggle('is-cutting', on);
    if (on) { ensureCutters().then(ok => { if (ok) { engL.render(); drawBox(); } }); drawBox(); }
  }

  /* ── the camera: one tween over (theta, zoom); a new line turns the ring ────── */
  let cam = { theta: 40.74, z: 0 }, camT = null, activeF = 0, typing = false, kbOpen = false;
  const U = 1000 / 3500;
  const live = document.createElement('div'); live.className = 'pdp-hero--main-image dlb-live';
  live.innerHTML = '<span class="dlb-cap"></span>'; live.firstChild.textContent = dlT('lillo.your_engraving', 'Your engraving');
  function applyCam() {
    if (!D) return;
    const R = camEl.getBoundingClientRect(), W = R.width, H = R.height; if (!W || !H) return;
    const inLive = live.contains(camEl);
    const rho = 90 - cam.theta, t = cam.theta * Math.PI / 180, rm = (D.mark.r_top + D.mark.r_base) / 2;
    const pB = [D.cx + rm * Math.cos(t), D.cy + rm * Math.sin(t)];
    const barTop = inLive ? H : bar.getBoundingClientRect().top - R.top;
    const qB = inLive ? [W / 2, H * 0.64] : [W / 2, Math.max(96, barTop - 46)];
    const sB = inLive ? Math.min(0.62, (W - 40) / 880) : Math.min(0.42, (W - 40) / 880), sW = Math.min(W, H) * 0.9 / (2 * (D.r_outer || 900)), z = cam.z;
    const p = [D.cx + (pB[0] - D.cx) * z, D.cy + (pB[1] - D.cy) * z];
    const q = [W / 2 + (qB[0] - W / 2) * z, H / 2 + (qB[1] - H / 2) * z];
    const s = Math.exp(Math.log(sW) * (1 - z) + Math.log(sB) * z);
    stage.style.transform = `translate(${q[0]}px,${q[1]}px) rotate(${rho}deg) scale(${s / U}) translate(${-p[0] * U}px,${-p[1] * U}px)`;
    camEl.style.setProperty('--vr', (880 * s) + 'px'); camEl.style.setProperty('--vo', String(1 - z));
    camEl.classList.add('is-ready');                       // placed: the picture may show (never unplaced at 1:1)
  }
  function camTo(target, ms) {
    const from = Object.assign({}, cam), to = Object.assign({}, cam, target);
    if (camT) cancelAnimationFrame(camT.raf);
    if (RM || !ms) { cam = to; applyCam(); return; }
    const t0 = performance.now(); camT = { raf: 0 };
    const step = now => {
      const k = Math.min(1, (now - t0) / ms), e = ease(k);
      cam = { theta: from.theta + (to.theta - from.theta) * e, z: from.z + (to.z - from.z) * e };
      applyCam();
      if (k < 1) camT.raf = requestAnimationFrame(step); else camT = null;
    };
    camT.raf = requestAnimationFrame(step);
  }

  /* ── the gallery ───────────────────────────────────────────────────────────────
     Eliau, 18 Sep: "keep the first picture, the actual first picture. And this one with the name
     should be there only when you type the name… or when you scroll on the pictures and you see
     the round picture of the ring." So: the product's pictures keep their order; while a name is
     typed on a desktop the live view sits first, on the left; otherwise the name is cut into the
     product's own round FRONT photo, in its own place. That photo is pixel-identical to the render
     the geometry is measured on (checked for both cameras), so the cut is applied straight onto
     its pixels (out = photo × T): no overlay, no seam, full resolution. */
  const closeUp = document.createElement('canvas'); closeUp.width = 1200; closeUp.height = 1200;   // for the small thumbnail only
  const imagesWrap = () => $('[data-pdp-images]', hero);
  const findFront = () => { const w = imagesWrap(); return w ? $$('img.pdp-hero--main-image', w).find(i => /face on/i.test(i.alt) || /front/i.test(i.dataset.dlbSrc || i.getAttribute('src') || '')) : null; };
  const f1 = document.createElement('input'), f2in = document.createElement('input');
  const fCut = document.createElement('canvas');
  let engF = null, frontReady = null, frontURL = null, frontTurn = 0;
  function frontPlateUrl(img) {                             // the gallery's own photo at 1800 px
    const z = img.dataset.dlbZoom || img.dataset.zoomSrc || img.getAttribute('src') || '';
    return /([?&])width=\d+/.test(z) ? z.replace(/([?&])width=\d+/, '$1width=1800') : z + (z.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
  }
  function ensureFront() {
    if (frontReady) return frontReady;
    const img = findFront();
    if (!img || !cfg.hasPlate) return (frontReady = Promise.resolve(false));
    const url = frontPlateUrl(img);
    frontReady = Promise.all([ensureCutters(), loadImg(url)]).then(([ok, pic]) => {
      if (!ok || !pic || !pic.naturalWidth) return false;
      fCut.width = pic.naturalWidth; fCut.height = pic.naturalHeight;
      engF = DeLevilleEngraver({ note: null, loupe: null, canvas: fCut, inputs: [f1, f2in], dataUrl: cfg.engraveData,
        plateUrl: () => url, plate: { origin: [0, 0], scale: pic.naturalWidth / 3500 }, gold: cfg.gold, weight: 500 });
      return waitReady(engF);
    }).catch(() => false);
    return frontReady;
  }
  function restoreFront() {
    const img = findFront(); if (!img || !img.dataset.dlbSrc) return;
    img.setAttribute('src', img.dataset.dlbSrc);
    if (img.dataset.dlbSrcset) img.setAttribute('srcset', img.dataset.dlbSrcset);
    img.dataset.zoomSrc = img.dataset.dlbZoom || img.dataset.zoomSrc; img.alt = img.dataset.dlbAlt || img.alt;
    ['dlbSrc', 'dlbSrcset', 'dlbZoom', 'dlbAlt'].forEach(k => { delete img.dataset[k]; });
    if (frontURL) { URL.revokeObjectURL(frontURL); frontURL = null; }
  }
  async function applyFront() {
    const turn = ++frontTurn;                               // a newer call wins
    if (!st.e1 || !cfg.hasPlate) { restoreFront(); return; }
    if (!(await ensureFront()) || turn !== frontTurn) return;
    const img = findFront(); if (!img) return;
    f1.value = st.e1; f2in.value = ''; f2in.disabled = true;     // the gallery's photo is YOUR ring: its one name (11 Oct)
    engF.render();
    composeThumb();
    const blob = await new Promise(res => fCut.toBlob(res, 'image/jpeg', 0.92));
    if (!blob || turn !== frontTurn) return;
    const url = URL.createObjectURL(blob);
    if (!img.dataset.dlbSrc) {
      img.dataset.dlbSrc = img.getAttribute('src'); img.dataset.dlbSrcset = img.getAttribute('srcset') || '';
      img.dataset.dlbZoom = img.dataset.zoomSrc || ''; img.dataset.dlbAlt = img.alt;
    }
    img.removeAttribute('srcset'); img.setAttribute('src', url); img.dataset.zoomSrc = url;
    img.alt = dlT('lillo.engraved_alt', '{alt}, engraved {names}').replace('{alt}', img.dataset.dlbAlt).replace('{names}', [st.e1, st.e2].filter(Boolean).join(' ' + dlT('lillo.and', 'and') + ' '));
    if (frontURL) URL.revokeObjectURL(frontURL);
    frontURL = url;
  }
  /* the zoom lists its pictures once, at load: when it opens the round photo, show the engraved one */
  const lbxImg = $('[id^="pdp-lbx-"] .pdp-lbx__img');
  if (lbxImg) {
    const mo = new MutationObserver(() => {
      const img = findFront();
      if (img && frontURL && img.dataset.dlbZoom && lbxImg.getAttribute('src') === img.dataset.dlbZoom) lbxImg.setAttribute('src', frontURL);
    });
    mo.observe(lbxImg, { attributes: true, attributeFilter: ['src'] }); off.push(() => mo.disconnect());
  }
  function fixProgress() {
    const w = imagesWrap(), b = $('.pdp-hero--mobile-progress-bar', hero);
    if (w && b) b.style.width = (100 / Math.max(1, w.children.length)) + '%';
  }
  function composeThumb() {                                  // the lower arc, turned so the names read, for the 64 px thumbnail
    if (!D) return;
    const c = closeUp.getContext('2d'), Wd = closeUp.width;
    const theta = SP[0].centre, t = theta * Math.PI / 180;
    const s = Wd / 1700, offR = 430, p = [D.cx + offR * Math.cos(t), D.cy + offR * Math.sin(t)];
    c.setTransform(1, 0, 0, 1, 0, 0); c.fillStyle = '#efeeeb'; c.fillRect(0, 0, Wd, Wd);
    c.translate(Wd / 2, Wd / 2); c.rotate((90 - theta) * Math.PI / 180); c.scale(s, s); c.translate(-p[0], -p[1]);
    c.imageSmoothingQuality = 'high';
    c.drawImage(fCut, 0, 0, 3500, 3500);
    c.setTransform(1, 0, 0, 1, 0, 0);
    const tc = $('[data-dlb-thumb-canvas]', root).getContext('2d');
    tc.clearRect(0, 0, 192, 192); tc.drawImage(closeUp, 160, 300, 880, 880, 0, 0, 192, 192);   // the lower arc, both names
  }
  function renderGallery() {
    const w = imagesWrap(); if (!w) return;
    live.remove();
    if (cfg.hasPlate && desk() && typing) { w.insertBefore(live, w.firstChild); requestAnimationFrame(applyCam); }   // only while typing
    fixProgress();
    applyFront();
  }

  /* ── engraving on the page ─────────────────────────────────────────────────── */
  function renderEn() {
    const on = !!st.e1;
    $('[data-dlb-en-open]', root).hidden = on || enOpen; $('[data-dlb-en-done]', root).hidden = !on || enOpen;
    const wk = $('[data-dlb-en-work]', root); if (wk) wk.hidden = !enOpen;
    enSec.classList.toggle('is-open', enOpen);
    $('[data-dlb-e1]', root).textContent = st.e1; const e2 = $('[data-dlb-e2]', root); e2.textContent = st.e2; e2.hidden = !st.e2;
    const how = $('[data-dlb-e-how]', root); if (how) how.textContent = one() ? (st.e2 ? how.dataset.twoO : how.dataset.oneO) : (st.e2 ? how.dataset.two : how.dataset.one);
    if (ringsReady) ringsUpdate();                         // folded and empty, the loupes go back to the sample name
    $('[data-dlb-thumb]', root).hidden = !(on && cfg.hasPlate);
    $('[data-dlb-en-done]', root).classList.toggle('is-plain', !(on && cfg.hasPlate));
    const box = $('[data-dlb-box]', root), work = $('[data-dlb-en-work]', root);
    if (box) box.hidden = !cfg.hasPlate;
    if (work) work.classList.toggle('is-plain', !cfg.hasPlate);
    renderFlow();
  }
  function syncFields() {
    if (document.activeElement !== eng1) eng1.value = st.e1;
    if (document.activeElement !== eng2) eng2.value = st.e2;
    const two = st.two; f2.hidden = one() ? !two : false; eng2.disabled = !two; $('[data-dlb-more]', fieldsEl).hidden = true;
    /* option A: the exchange has the tick, only you has "+ A second name on the other half"; an empty or same field shows
       your name in grey, which is what it will carry */
    const sw = $('[data-dlb-same-w]', fieldsEl), m2 = $('[data-dlb-more2]', fieldsEl);
    if (sw) { sw.hidden = one(); $('[data-dlb-same]', sw).checked = !two; }
    if (m2) m2.hidden = !one() || two;
    /* two narrow fields side by side: the short hint, never a cut-off one */
    eng1.placeholder = tt('add_a_name', 'Add a name');
    nameHints();
    eng2.placeholder = (!two || !eng2.value) && eng1.value.trim() ? eng1.value.trim() : tt('add_a_name', 'Add a name');
    if (!two && document.activeElement !== eng2) eng2.value = '';
    $$('[data-dlb-count]', root).forEach(b => b.setAttribute('aria-checked', String((b.dataset.dlbCount === '2') === two)));   // the choice sits above the rings now
    const l1 = $('[data-dlb-flabel1]', fieldsEl); if (l1) l1.textContent = one() ? (two ? l1.dataset.twoO : l1.dataset.oneO) : (two ? l1.dataset.two : l1.dataset.one);
    const rg = $('[data-dlb-rings]', root); if (rg) rg.classList.toggle('is-two', two);
  }

  /* phone: the sheet (option C) — the name typed on a full-screen ring, keyboard below */
  let sheetOpener = null;
  const vv = window.visualViewport;
  function vvLayout() {
    if (sheet.hidden) return;
    if (vv) { sheet.style.height = vv.height + 'px'; sheet.style.transform = `translateY(${vv.offsetTop}px)`; }
    if (!cfg.hasPlate) camNone.style.bottom = (bar.offsetHeight + 8) + 'px';
    applyCam();
  }
  if (vv) { listen(vv, 'resize', vvLayout); listen(vv, 'scroll', vvLayout); }
  function openEngrave(second, big) {
    if (!big) {
      enOpen = true; renderEn(); ensureRings().then(ok => { if (ok) { ringsUpdate(); ringsDraw(); } });
      enSec.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' }); (second ? eng2 : eng1).focus({ preventScroll: true }); return;
    }
    sheetOpener = document.activeElement;
    bar.appendChild(fieldsEl);                             // the fields travel into the sheet, and back on Done
    sheet.hidden = false; document.documentElement.style.overflow = 'hidden';
    camEl.classList.toggle('is-none', !cfg.hasPlate); camNone.hidden = !!cfg.hasPlate;
    if (!cfg.hasPlate) {                                   // no engraving picture for this piece yet: show the ring itself
      const first = $('[data-pdp-images] img', hero), src = first && (first.currentSrc || first.src);
      let pic = $('img', camNone);
      if (src && !pic) { pic = new Image(); pic.alt = first.alt || ''; camNone.prepend(pic); }
      if (pic && src && pic.getAttribute('src') !== src) pic.src = src;
    }
    fullEl.crossOrigin = 'anonymous'; fullEl.src = cfg.plates[cfg.gold].full;
    syncFields(); if (second) { f2.hidden = false; eng2.disabled = false; $('[data-dlb-more]', fieldsEl).hidden = true; }
    activeF = second ? 1 : 0;
    ensureCutters().then(ok => { if (ok) { cam = { theta: SP[activeF].centre, z: kbOpen ? 1 : 0 }; engL.render(); vvLayout(); } });
    vvLayout();
    (second ? eng2 : eng1).focus({ preventScroll: true });             // inside the tap: the phone raises its keyboard
  }
  function commitSheet() {
    st.e1 = eng1.value.trim(); st.e2 = eng2.disabled ? '' : eng2.value.trim();
    if (!st.e1 && st.e2) { st.e1 = st.e2; st.e2 = ''; }
    save(); pushEngraving();
    if (document.activeElement) document.activeElement.blur();
    sheet.hidden = true; kbOpen = false; document.documentElement.style.overflow = '';
    $('[data-dlb-en-inline]', root).appendChild(fieldsEl); // the fields go back into the row
    enSec.classList.remove('is-flag');
    syncFields(); renderEn(); renderGallery(); drawBox();
    if (st.e1) { toast(dlT('lillo.engraving_added', 'Engraving added')); enSec.classList.remove('is-set-anim'); void enSec.offsetWidth; enSec.classList.add('is-set-anim'); }
    setTimeout(() => { const b = $('[data-dlb-box]', root); if (b && b.offsetParent) b.focus({ preventScroll: true }); }, 0);
  }
  $('[data-dlb-sheet-done]', sheet).addEventListener('click', commitSheet);
  function setField(i) {
    const was = activeF; activeF = i;
    eng1.classList.toggle('is-active', i === 0); eng2.classList.toggle('is-active', i === 1);
    if (SP) camTo({ theta: SP[i].centre, z: kbOpen ? 1 : cam.z }, was !== i ? 1100 : 420);
  }
  function setKb(on) { kbOpen = on; requestAnimationFrame(() => camTo({ z: on ? 1 : 0 }, 520)); }

  /* desktop: the fields on the page, the big picture cut live */
  function deskFocus(i) {
    const was = typing && live.isConnected ? activeF : -1;
    typing = true; activeF = i;
    eng1.classList.toggle('is-active', i === 0); eng2.classList.toggle('is-active', i === 1);
    if (!cfg.hasPlate) return;
    ensureCutters().then(ok => {
      if (!ok) return;
      if (!live.isConnected) { live.prepend(camEl); fullEl.crossOrigin = 'anonymous'; fullEl.src = cfg.plates[cfg.gold].full; cam = { theta: SP[i].centre, z: 0.62 }; renderGallery(); }
      const ic = $('.pdp-hero--image-container', hero); if (ic) ic.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' });
      engL.render();
      camTo({ theta: SP[i].centre, z: 1 }, was === -1 ? 520 : was !== i ? 1100 : 300);
    });
  }
  function deskBlur() {
    typing = false; eng1.classList.remove('is-active'); eng2.classList.remove('is-active');
    renderGallery();                                        // the live view leaves; the name goes onto the round photo
  }
  [eng1, eng2].forEach((inp, i) => {
    inp.addEventListener('input', () => { if (turnIsOn) TURN.side(i); ringsUpdate(); });   // typing brings its own half to the front, even after a swipe
    inp.addEventListener('focus', () => ringsFocus(i));
    inp.addEventListener('focus', () => {
      if (desk()) return deskFocus(i);
      /* drawBox() as well as setCutting(): moving from the first name to the second leaves the box
         already open, so setCutting no-ops and the window would keep showing the first space.
         Eliau, 22 Sep, with "Piha" typed under "Eliau": "I don't see any text on that page." */
      if (sheet.hidden) { activeF = i; setCutting(true); drawBox(); return; }
      setField(i); if (!kbOpen) setKb(true);
    });
    inp.addEventListener('blur', () => setTimeout(() => {
      if (document.activeElement === eng1 || document.activeElement === eng2) return;
      if (desk()) deskBlur();
      else if (!sheet.hidden) setKb(false);
      else { setCutting(false); renderGallery(); }         // typed in the row: the name goes onto the round photo
    }, 80));
    inp.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); if (i === 0 && !f2.hidden) eng2.focus(); else if (desk() || sheet.hidden) inp.blur(); else commitSheet(); } });
  });
  $('[data-dlb-more]', fieldsEl).addEventListener('click', () => {
    f2.hidden = false; eng2.disabled = false; $('[data-dlb-more]', fieldsEl).hidden = true;
    eng2.focus({ preventScroll: true });                   // turns the ring to the next space
    if (engL) engL.render();
  });
  $('[data-dlb-less]', fieldsEl).addEventListener('click', () => {
    eng2.value = ''; f2.hidden = true; eng2.disabled = true; $('[data-dlb-more]', fieldsEl).hidden = false;
    if (engL) engL.render(); if (desk()) liveCommit(); eng1.focus({ preventScroll: true });
  });
  /* ── one name or two (Eliau, 11 Oct) ──────────────────────────────────────── */
  let keep2 = '';
  function setTwo(two) {
    if (st.two === two) return;
    if (!two) { keep2 = eng2.value; st.e2 = ''; } else if (!st.e2 && keep2) st.e2 = keep2;
    st.two = two; syncFields(); liveCommit(); save();
    pushEngraving(); renderEn();                          // st.e2 was cleared above, so liveCommit saw no change: the order's field must still be emptied
    ringsUpdate(); ringsDraw();
    (two && eng1.value.trim() ? eng2 : eng1).focus({ preventScroll: true });
  }
  $$('[data-dlb-count]', fieldsEl).forEach(b => b.addEventListener('click', () => setTwo(b.dataset.dlbCount === '2')));
  $('[data-dlb-en-close]', fieldsEl).addEventListener('click', () => { foldStep(); });
  const sameBox = $('[data-dlb-same]', fieldsEl), more2 = $('[data-dlb-more2]', fieldsEl);
  if (sameBox) sameBox.addEventListener('change', () => setTwo(!sameBox.checked));
  if (more2) more2.addEventListener('click', () => setTwo(true));
  /* their field shows your name in grey while it is empty (only the hint, never syncFields: that rewrites values) */
  eng1.addEventListener('input', () => { if (!eng2.value) eng2.placeholder = eng1.value.trim() || tt('add_a_name', 'Add a name'); });
  /* 15 Oct: engraved = no returns, said the moment a name is typed; without a name, a plain way past the engraving */
  const skipBtn = $('[data-dlb-skip]', fieldsEl);
  function nameHints() {                                  // queried here, not from consts: syncFields may run first
    const noRet = $('[data-dlb-noreturn]', fieldsEl), skipBtn = $('[data-dlb-skip]', fieldsEl);
    const named = !!(eng1.value.trim() || (!eng2.disabled && eng2.value.trim()));
    if (noRet) noRet.hidden = !named;
    if (skipBtn) skipBtn.hidden = named;
  }
  [eng1, eng2].forEach(i => i.addEventListener('input', nameHints));
  if (skipBtn) skipBtn.addEventListener('click', () => {
    eng1.value = ''; eng2.value = ''; liveCommit(); pushEngraving(); nameHints();
    if (ringsReady) { ringsUpdate(); ringsDraw(); }
    foldStep();
  });

  /* ── the two rings, side by side: each its own name, cut by the live engraver on the FRONT render ───────
     Eliau, 11 Oct: one name -> the same name on both; two names -> one name on each; the ring whose name is
     being typed comes a little closer. Each ring: a hidden input (its name) -> its engraver -> its canvas,
     drawn into the page turned so the name reads along the bottom of the ring. */
  const ringsEl = $('[data-dlb-rings]', root), ringCv = $$('[data-dlb-ring-canvas]', root);
  const ringIn = [document.createElement('input'), document.createElement('input')];
  const ringCut = [document.createElement('canvas'), document.createElement('canvas')];
  /* 11 Oct (2), Eliau on the open engraving: "this confuses many". The rings come in close on the band so the name
     reads as it is typed (they were whole rings, the name a few pixels high), and the choice moves above them. */
  const Z_REST = 0.85;
  const ringEng = [null, null], ringZ = [Z_REST, Z_REST], ringZT = [Z_REST, Z_REST];
  let ringsReady = null, ringPlate = null, ringRaf = 0;
  /* 15 Oct (4), Eliau: "i like the flip of the ring, its the animation that makes them understand the two halves". Where
     the piece and gold have been rendered turning, one ring turned over stands where the two loupes stood: your half's
     rim facing (your name), turning over to theirs when their field is chosen (assets/dl-lillo-turn.js, the atelier's
     turn, frames from lillo.deleville.co). Anything else keeps the loupes. */
  const turnEl = $('[data-dlb-turn]', root), turnCap = turnEl && $('[data-dlb-turn-cap]', turnEl);
  let TURN = null, turnIsOn = false, turnIntroDone = false;
  function turnGate() {
    if (!turnEl || !cfg.turnJs || !cfg.hasPlate || !window.DeLevilleEngraver) return Promise.resolve(false);
    return (window.DLLilloTurn ? Promise.resolve() : new Promise((ok, bad) => {
      const s = document.createElement('script'); s.src = cfg.turnJs; s.onload = ok; s.onerror = bad; document.head.appendChild(s);
    })).then(() => {
      /* drag: Eliau, 15 Oct, on the live page: "Can you make that you can swipe left and right on the ring to move side?" */
      TURN = window.DLLilloTurn({ canvas: $('[data-dlb-turn-canvas]', turnEl), base: cfg.turnBase, onSide: turnCaption, drag: true });
      if (!TURN.has(cfg.tier, cfg.gold)) return false;
      return TURN.set(cfg.tier, cfg.gold, turnNames());
    }).catch(() => false);
  }
  function turnNames() {
    const ra = eng1.value, rb = st.two && eng2.value.trim() ? eng2.value : eng1.value;
    return !ra.trim() && !rb.trim() ? [SAMPLE, SAMPLE] : [ra, rb];   // empty: the sample, cut, as the loupes did (11 Oct)
  }
  function turnCaption(s) {
    if (!turnCap) return;
    const d = turnCap.dataset; turnCap.textContent = one() ? (s ? d.other : d.one) : (s ? d.theirs : d.yours);
  }
  function setTurn(on) {
    turnIsOn = on; turnEl.hidden = !on; enSec.classList.toggle('has-turn', on);
    if (on) turnCaption(TURN.at);
  }
  /* the step opens: the ring turns over once by itself and back, so the two halves are seen before a name is typed */
  function turnIntro() { if (turnIsOn && !turnIntroDone && enOpen) { turnIntroDone = true; TURN.over(); } }
  function ensureRings() {
    if (ringsReady) return ringsReady;
    return (ringsReady = turnGate().then(on => { if (on) { setTurn(true); return true; } return ensureLoupes(); }));
  }
  let loupesReady = null;
  function ensureLoupes() {
    if (loupesReady) return loupesReady;
    if (!window.DeLevilleEngraver || !cfg.hasPlate || !ringCv.length) return (loupesReady = Promise.resolve(false));
    const url = cfg.plates[cfg.gold].full;
    loupesReady = Promise.all([ensureCutters(), loadImg(url)]).then(([ok, pic]) => {
      if (!ok || !pic || !pic.naturalWidth) return false;
      ringPlate = pic; ringsDraw();
      for (let i = 0; i < 2; i++) {
        ringCut[i].width = pic.naturalWidth; ringCut[i].height = pic.naturalHeight;
        ringEng[i] = DeLevilleEngraver({ note: null, loupe: null, canvas: ringCut[i], inputs: [ringIn[i]], dataUrl: cfg.engraveData,
          plateUrl: () => url, plate: { origin: [0, 0], scale: pic.naturalWidth / 3500 }, gold: cfg.gold, weight: 500,
          onChange: () => drawRing(i) });
      }
      return Promise.all(ringEng.map(waitReady)).then(() => true);
    }).catch(() => false);
    return loupesReady;
  }
  /* Eliau, 11 Oct: "show the actual engraving in the gold, writing Lillo". Folded and still empty, both loupes carry
     this name, really cut by the engraver; the moment the engraving opens, the fields' own values take over. */
  const SAMPLE = 'Lillo';
  function ringsUpdate() {
    if (turnIsOn) { TURN.set(cfg.tier, cfg.gold, turnNames()); turnCaption(TURN.at); return; }
    const ra = eng1.value, rb = st.two && eng2.value.trim() ? eng2.value : eng1.value;
    let a = ra, b = rb;
    if (!ra.trim() && !rb.trim()) a = b = SAMPLE;   // nothing typed yet, folded or open: the sample, cut
    [a, b].forEach((v, i) => { if (ringIn[i].value !== v) { ringIn[i].value = v; if (ringEng[i] && ringEng[i].ready()) ringEng[i].render(); } });
    $$('[data-dlb-ring-name]', root).forEach((n, i) => { n.textContent = (i ? rb : ra).trim(); });   // the name they typed, under its ring
  }
  function drawRing(i) {
    const cv = ringCv[i]; if (!cv) return;
    const c = cv.getContext('2d'), W = cv.width;
    c.setTransform(1, 0, 0, 1, 0, 0); c.fillStyle = '#efeeeb'; c.fillRect(0, 0, W, W);
    const src = ringEng[i] && ringEng[i].ready() ? ringCut[i] : ringPlate;
    if (!src || !D || !SP) return;
    const t = SP[0].centre * Math.PI / 180, z = ringZ[i];
    const rMid = (D.mark.r_top + (D.ink_bot || (D.mark.r_base + 18))) / 2, R = D.r_outer || (D.mark.r_base + 90);
    const px = D.cx + rMid * Math.cos(t) * z, py = D.cy + rMid * Math.sin(t) * z;
    const span = 2 * R * (1.1 - 0.62 * z);                // the whole ring at rest, the name's arc when close
    c.translate(W / 2, W / 2); c.rotate(Math.PI / 2 - t); c.scale(W / span, W / span); c.translate(-px, -py);
    c.imageSmoothingQuality = 'high';
    c.drawImage(src, 0, 0, 3500, 3500);
    c.setTransform(1, 0, 0, 1, 0, 0);
    drawLoupes(i);
  }
  /* the folded row's two loupes: the same cut ring, close on the name (the band's arc across ~760 render px) */
  const LP_SPAN = 760;
  function drawLoupes(i) {
    const src = ringEng[i] && ringEng[i].ready() ? ringCut[i] : null;
    if (!src || !D || !SP) return;
    const t = SP[0].centre * Math.PI / 180, rMid = (D.mark.r_top + (D.ink_bot || (D.mark.r_base + 18))) / 2;
    const px = D.cx + rMid * Math.cos(t), py = D.cy + rMid * Math.sin(t);
    $$(`[data-dlb-lp="${i}"]`, root).forEach(cv => {
      const c = cv.getContext('2d'), W = cv.width;
      c.setTransform(1, 0, 0, 1, 0, 0); c.fillStyle = '#efeeeb'; c.fillRect(0, 0, W, W);
      c.translate(W / 2, W / 2); c.rotate(Math.PI / 2 - t); c.scale(W / LP_SPAN, W / LP_SPAN); c.translate(-px, -py);
      c.imageSmoothingQuality = 'high'; c.drawImage(src, 0, 0, 3500, 3500); c.setTransform(1, 0, 0, 1, 0, 0);
    });
  }
  const ringsDraw = () => { drawRing(0); drawRing(1); };
  function ringsFocus(i) {
    if (turnIsOn) { if (i >= 0) TURN.side(i); return; }    // the ring turns over to the half being named
    /* two names: the ring being named comes close, the other stays whole; one name: both a little closer */
    if (i < 0) { ringZT[0] = ringZT[1] = Z_REST; }
    else if (st.two) { ringZT[i] = 1; ringZT[1 - i] = Z_REST; }   /* "a bit zoomed in": the ring being named, a little closer */
    else { ringZT[0] = ringZT[1] = 0.95; }                        /* one name: both, together */
    if (ringsEl) $$('[data-dlb-ring]', ringsEl).forEach((f, k) => f.classList.toggle('is-active', i >= 0 && (st.two ? k === i : true)));
    cancelAnimationFrame(ringRaf);
    const z0 = ringZ.slice(), t0 = performance.now(), ms = RM ? 1 : 420;
    (function step(now) {
      const u = Math.min(1, (now - t0) / ms), e = u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
      ringZ[0] = z0[0] + (ringZT[0] - z0[0]) * e; ringZ[1] = z0[1] + (ringZT[1] - z0[1]) * e;
      ringsDraw();
      if (u < 1) ringRaf = requestAnimationFrame(step);
    })(t0);
  }
  camEl.addEventListener('pointerdown', () => { if (document.activeElement === eng1 || document.activeElement === eng2) document.activeElement.blur(); });
  $('[data-dlb-en-open]', root).addEventListener('click', () => openEngrave(false));
  $('[data-dlb-en-edit]', root).addEventListener('click', () => openEngrave(false));
  $('[data-dlb-en-rm]', root).addEventListener('click', () => {
    st.e1 = ''; st.e2 = ''; save(); pushEngraving(); syncFields(); renderEn(); renderGallery(); toast(dlT('lillo.engraving_removed', 'Engraving removed'));
    $('[data-dlb-en-open]', root).focus({ preventScroll: true });
  });
  function seeInPictures() {
    const img = findFront(), w = imagesWrap(), b = RM ? 'auto' : 'smooth';
    if (!img || !w) return;
    if (desk()) { const ic = $('.pdp-hero--image-container', hero); if (ic) ic.scrollTo({ top: img.offsetTop, behavior: b }); }
    else { w.scrollTo({ left: img.offsetLeft, behavior: b }); scrollTo({ top: 0, behavior: b }); }
  }
  $('[data-dlb-thumb]', root).addEventListener('click', seeInPictures);
  /* the little box: on a phone it opens the ring full screen, on a desktop it goes to the picture */
  $('[data-dlb-box]', root).addEventListener('click', () => { if (desk()) seeInPictures(); else openEngrave(activeF === 1, true); });

  /* ══ 13 Oct 2026: who will wear it, the exchange, the half they give you, the pair link, the guide ══════════════
     Eliau: "I like the animation, lets go. call that a exchange"; "after that step, the person can choose the size, if
     he chooses you each wear one, also give an option to buy two rings directly and have two names etc. or a buy link
     as a pair, that shows what the other person ordered and how they will look together, also add a pop up mini guide".
     Still always the pair: one order = two halves, one cut for your hand, one for theirs (live /pages/lillo). The
     exchange = your order + theirs; each closes their own half around the one they were given. Only you = the same
     order, both halves in your size. Mockups and every round: deleville-mockups/lillo-whiteglove/README.md. */
  const RING = k => cfg.rings[k] || cfg.rings[cfg.piece] || { top: cfg.halves.top, bottom: cfg.halves.bottom };
  const RTL = () => getComputedStyle(root).direction === 'rtl';
  const tierName = k => { const t = (k || '').split('-')[0]; return t.charAt(0).toUpperCase() + t.slice(1); };
  /* the order stays in English for the bench (CLAUDE.md): a piece by its handle, never by its translated title */
  const enTitle = k => { const g = (k || '').split('-')[1] || ''; return `LILLO ${tierName(k)}, ${g.charAt(0).toUpperCase() + g.slice(1)} Gold`; };

  /* the four halves in a box: your set (what you buy) full size on the start side, theirs small and faded on the end
     side. The exchange: your bottom half (cut for their hand) lifts and crosses to their set; their bottom half (cut for
     your hand) dips under and comes to yours. Nothing ever closes, and every set ends in ONE size. Proportions from
     who-wears-04.html (a 138 x 78 box); the crossing never stacks two halves (the first cut did, and read as a close). */
  function makeSets(box, mine, theirs, even) {
    const els = {};
    ['C', 'D', 'A', 'B'].forEach(k => {
      let h = $(`[data-dlb-x="${k}"]`, box);
      if (!h) { h = document.createElement('span'); h.className = 'dlb-hx'; h.dataset.dlbX = k; h.innerHTML = '<img alt="">'; box.appendChild(h); }
      els[k] = h;
    });
    const set = (k, url) => { const i = $('img', els[k]); if (i.getAttribute('src') !== url) i.src = url; };
    function pics(m, t) { set('A', m.top); set('B', m.bottom); set('C', t.top); set('D', t.bottom); }
    pics(mine, theirs);
    const E = u => u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2, C = (u, a, b) => Math.min(1, Math.max(0, (u - a) / (b - a))), L = (a, b, u) => a + (b - a) * u;
    function draw(u) {
      const W = box.clientWidth || 138, k = W / 138, flip = RTL();
      const X = x => (flip ? 138 - x : x) * k, rot = flip ? 90 : -90;
      /* even (the invitation): both sets the same size and both lit, because both rings are someone's */
      const ML = even ? { x: 14, y: 39, s: .82 } : { x: 19, y: 39, s: 1 }, MR = even ? { x: 46, y: 39, s: .82 } : { x: 59, y: 39, s: 1 };
      const TL = even ? { x: 92, y: 39, s: .82 } : { x: 97.5, y: 44.5, s: .7 }, TR = even ? { x: 124, y: 39, s: .82 } : { x: 125.5, y: 44.5, s: .7 };
      const FO = even ? 1 : .45;
      const lift = E(C(u, 0, .2)) * (1 - E(C(u, .8, 1))), gb = E(C(u, .2, .73)), gd = E(C(u, .25, .78));
      const fb = 1 - .2 * Math.sin(Math.PI * gb), fd = 1 - .2 * Math.sin(Math.PI * gd);
      const put = (key, x, y, sc, o, dx) => {
        const h = els[key], hh = 64 * k * sc;
        h.style.transform = `translate(${(X(x) - 15 * k + (dx || 0) * k).toFixed(2)}px, ${(y * k - 32 * k).toFixed(2)}px) scale(${sc.toFixed(3)})`;
        h.style.opacity = o.toFixed(3); h.style.width = 30 * k + 'px'; h.style.height = 64 * k + 'px';
        $('img', h).style.width = 64 * k + 'px'; $('img', h).style.transform = `translate(-50%,-50%) rotate(${rot}deg)`;
        void hh;
      };
      put('A', ML.x, ML.y, ML.s, 1, -3 * lift * (flip ? -1 : 1));
      put('C', TL.x, TL.y, TL.s, FO, 4 * lift * (flip ? -1 : 1));
      put('D', L(TR.x, MR.x, gd), L(TR.y, MR.y, gd) + 6 * lift + 12 * Math.sin(Math.PI * gd), L(TR.s, MR.s, gd) * fd, L(FO, 1, gd));
      put('B', L(MR.x, TR.x, gb), L(MR.y, TR.y, gb) - 9 * lift - 15 * Math.sin(Math.PI * gb), L(MR.s, TR.s, gb) * fb, L(1, FO, gb));
    }
    let raf = 0, looping = false;
    /* Eliau, 13 Oct: "have an animation always going, always live of the exchange". A cycle: fade in on what each buys,
       a breath, the exchange, a longer breath on what each wears, fade out. Never played backwards: the halves do not
       un-exchange, the picture simply starts again. */
    function loop(ms) {
      cancelAnimationFrame(raf); looping = true;
      if (RM) { box.style.opacity = ''; draw(1); return; }
      const FI = 450, HB = 700, HA = 2400, FO = 450, cyc = FI + HB + ms + HA + FO, t0 = performance.now();
      const step = now => {
        if (!looping) return;
        const t = (now - t0) % cyc;
        if (t < FI) { box.style.opacity = String(t / FI); draw(0); }
        else if (t < FI + HB) { box.style.opacity = '1'; draw(0); }
        else if (t < FI + HB + ms) { box.style.opacity = '1'; draw((t - FI - HB) / ms); }
        else if (t < FI + HB + ms + HA) { box.style.opacity = '1'; draw(1); }
        else { box.style.opacity = String(1 - (t - FI - HB - ms - HA) / FO); draw(1); }
        raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }
    /* loop only while the box is on screen (and the browser already rests rAF in a hidden tab) */
    function loopInView(ms) {
      if (!('IntersectionObserver' in window)) { loop(ms); return () => {}; }
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { if (!looping) loop(ms); } else stopIt(); }, { threshold: 0.2 });
      io.observe(box); return () => io.disconnect();
    }
    function stopIt() { looping = false; cancelAnimationFrame(raf); box.style.opacity = ''; }
    function play(ms, done) {
      cancelAnimationFrame(raf); looping = false; box.style.opacity = '';
      if (RM) { draw(1); if (done) done(); return; }
      const t0 = performance.now();
      const step = now => { const u = Math.min(1, (now - t0) / ms); draw(u); if (u < 1) raf = requestAnimationFrame(step); else if (done) done(); };
      draw(0); raf = requestAnimationFrame(step);
    }
    return { draw, play, pics, loop, loopInView, stop: stopIt };
  }

  /* ── the two tiles ── */
  const whoSec = $('[data-dlb-who]', root), setsBox = $('[data-dlb-sets]', root);
  const tileSets = setsBox ? makeSets(setsBox, cfg.halves, RING(st.pt)) : null;
  const isoImg = $('[data-dlb-iso]', root);
  if (isoImg) {
    const r = RING(cfg.piece);
    isoImg.addEventListener('error', () => { if (r.photo && isoImg.getAttribute('src') !== r.photo) { isoImg.parentNode.classList.add('is-photo'); isoImg.src = r.photo; } }, { once: true });
    isoImg.src = r.iso || r.photo || '';
  }
  function whoAlt() {
    /* only you: "your ring / their ring" become "one half / the other half"; "Two sizes" becomes "Your size" */
    $$('[data-dlb-alt]', document).filter(n => root.contains(n) || pop.contains(n) || sheet.contains(n)).forEach(n => {
      if (n.dataset.dlbOrig == null) n.dataset.dlbOrig = n.textContent;
      n.textContent = one() ? n.dataset.dlbAlt : n.dataset.dlbOrig;
    });
  }
  function renderWho() {
    $$('[data-dlb-who-pick]', root).forEach(b => b.setAttribute('aria-checked', String((b.dataset.dlbWhoPick === 'one') === one())));
    root.classList.toggle('dlb-is-one', one());
    whoAlt(); renderFlow();
  }
  function setWho(w) {
    if (st.who === w) return;
    if (w === 'one') { keepT = { theirs: st.theirs, later: st.later }; st.who = 'one'; st.theirs = st.yours; st.later = false; }
    else { st.who = 'two'; if (keepT) { st.theirs = keepT.theirs; st.later = !!keepT.later; } else st.theirs = null; keepT = null; }
    save(); pushSizes(); renderSizer(); renderRow(); syncFields(); renderEn(); renderWho();
  }
  $$('[data-dlb-who-pick]', root).forEach(b => b.addEventListener('click', () => {
    const w = b.dataset.dlbWhoPick;
    setWho(w);
    /* no Done under the tiles (15 Oct (4)): a size missing opens the sizes under them; reopened with both sizes set,
       the tap is the answer and the question folds back after a breath to see it land */
    if (unset('yours') || unset('theirs')) { editing = true; enOpen = false; renderRow(); renderSizer(); renderEn(); renderFlow(); }
    else if (whoOpen) setTimeout(() => { whoOpen = false; renderFlow(); }, 650);
  }));
  /* the exchange is always live (Eliau, 13 Oct), whichever tile is chosen, while it is on screen. Reduced motion: it
     rests on what each wears (two-tone). */
  if (tileSets) { tileSets.draw(RM ? 1 : 0); off.push(tileSets.loopInView(3000)); }

  /* ── the half they give you (the exchange only): both rings here, or a pair link ── */
  const ohSec = $('[data-dlb-oh]', root), ohHere = $('[data-dlb-oh-here]', root), ohLink = $('[data-dlb-oh-link]', root);
  const ohMe = $('[data-dlb-oh-me]', root), ohTo = $('[data-dlb-oh-to]', root), ohNote = $('[data-dlb-oh-note]', root);
  const STY = ['regale', 'essenza', 'segreto', 'puro'], GLD = ['yellow', 'rose', 'white'];
  function renderOh() {
    if (!ohSec) return;
    /* 14 Oct: the last line, shown once the sizes and the names are answered (or if their ring is already chosen) */
    const here = st.oh === 'here', ready = !unset('yours') && !unset('theirs') && !enOpen && !editing && enAuto;
    ohSec.hidden = one() || !(ready || here);
    $('[data-dlb-oh-line]', ohSec).setAttribute('aria-expanded', String(ohOpen));
    $('[data-dlb-oh-body]', ohSec).hidden = !ohOpen;
    const val = $('[data-dlb-oh-val]', ohSec);
    const pr = RING(st.pt).price || '';
    if (here) { const d = () => { const x = document.createElement('span'); x.className = 'dlb-dot'; x.textContent = ' · '; return x; }; val.replaceChildren(val.dataset.here, d(), RING(st.pt).title || '', d(), '+' + pr); }
    else val.textContent = val.dataset.link;
    const pn = $('[data-dlb-oh-pricenote]', ohSec); if (pn) pn.textContent = (pn.dataset.tpl || '').replace('{price}', pr);
    $$('[data-dlb-oh-pick]', ohSec).forEach(b => b.setAttribute('aria-checked', String((b.dataset.dlbOhPick === 'here') === here)));
    ohHere.hidden = !(ohOpen && here); ohLink.hidden = !(ohOpen && !here);
    if (ohSets) { ohSets.pics(cfg.halves, RING(here ? st.pt : cfg.other)); ohSets.draw(0); }
    if (st.oh === 'here') {
      const [pt, pg] = st.pt.split('-'), r = RING(st.pt);
      $('[data-dlb-oh-sty]', ohSec).replaceChildren(...STY.filter(t => GLD.some(g => cfg.rings[`${t}-${g}`])).map(t => {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio'); b.textContent = tierName(t);
        b.setAttribute('aria-checked', String(t === pt));
        b.addEventListener('click', () => { const k = cfg.rings[`${t}-${pg}`] ? `${t}-${pg}` : GLD.map(g => `${t}-${g}`).find(x => cfg.rings[x]); if (k) { st.pt = k; save(); renderOh(); } });
        return b;
      }));
      $('[data-dlb-oh-gold]', ohSec).replaceChildren(...GLD.filter(g => cfg.rings[`${pt}-${g}`]).map(g => {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio'); b.className = `is-${g}`;
        b.setAttribute('aria-checked', String(g === pg)); b.setAttribute('aria-label', dlT(`lillo.metal_${g}`, g));
        b.addEventListener('click', () => { st.pt = `${pt}-${g}`; save(); renderOh(); });
        return b;
      }));
      /* how the two will look together: your half and theirs, facing, apart (two fingers, two rings: never closed) */
      $('[data-dlb-oh-img="mine"]', ohSec).src = cfg.halves.top; $('[data-dlb-oh-img="theirs"]', ohSec).src = r.bottom;
      $('[data-dlb-oh-cap]', ohSec).textContent = `${cfg.title}  ·  ${r.title}`;
      $('[data-dlb-oh-sum]', ohSec).textContent = tt('their_ring_summary', 'Their ring: {piece}, {price}').replace('{piece}', r.title).replace('{price}', r.price);
    }
    if (!here) {
      if (document.activeElement !== ohMe) ohMe.value = st.me;
      if (ohTo && document.activeElement !== ohTo) ohTo.value = st.to || '';
      if (ohNote && document.activeElement !== ohNote) ohNote.value = st.note || '';
    }
    if (tileSets) tileSets.pics(cfg.halves, RING(st.oh === 'here' ? st.pt : cfg.other));
  }
  if (ohSec) {
    $('[data-dlb-oh-line]', ohSec).addEventListener('click', () => { ohOpen = !ohOpen; renderOh(); });
    $$('[data-dlb-oh-pick]', ohSec).forEach(b => b.addEventListener('click', () => {
      st.oh = b.dataset.dlbOhPick; save(); renderOh();
      if (st.oh === 'here') setTimeout(() => ohHere.scrollIntoView({ block: 'nearest', behavior: RM ? 'auto' : 'smooth' }), 0);
    }));
    ohMe.addEventListener('input', () => { st.me = ohMe.value.trim(); save(); });
    if (ohTo) ohTo.addEventListener('input', () => { st.to = ohTo.value.trim(); save(); });
    if (ohNote) ohNote.addEventListener('input', () => { st.note = ohNote.value.slice(0, 140); save(); });
    const see = $('[data-dlb-inv-see]', ohSec); if (see) see.addEventListener('click', () => openInv(myPair(), true));
    $('[data-dlb-share]', ohSec).addEventListener('click', async () => {
      const url = pairUrl(), text = st.to
        ? tt('invite_share_text', '{name}, I made you half of a LILLO. Now choose the half you give me.').replace('{name}', st.to)
        : tt('pair_share_text', 'I chose my LILLO. Now choose the half you give me.');
      try {
        if (navigator.share) { await navigator.share({ title: cfg.title, text, url }); return; }
      } catch (e) { if (e && e.name === 'AbortError') return; }
      try { await navigator.clipboard.writeText(url); toast(tt('link_copied', 'Link copied')); }
      catch (e) { window.prompt(tt('link_copied', 'Link copied'), url); }
    });
  }
  /* the pair link carries only what the other person needs: a first name, the piece, the two sizes. Never the
     engraving (it stays a surprise), never an address. */
  const b64u = o => btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const unb64u = v => JSON.parse(decodeURIComponent(escape(atob(v.replace(/-/g, '+').replace(/_/g, '/')))));
  /* + t (their first name), m (a few words, 140 at most) and l (the store language): what the invitation shows them */
  const myPair = () => ({ n: st.me || '', t: st.to || '', m: (st.note || '').trim(), k: cfg.piece, y: st.yours, p: st.later ? null : st.theirs,
    l: (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en' });
  /* Eliau, 13 Oct: "yes build the whatsapp preview on vercel". The link goes to lillo.deleville.co/i/<code> first
     (deleville-os, src/app/i): a message app's robot reads a preview made for these two people there, and a person is
     sent straight on to this piece with ?pair=<code>. On a preview theme it also carries the theme id, so the test lands
     on the draft. */
  const INVITE_HOST = 'https://lillo.deleville.co/i/';
  function pairUrl() {
    const th = window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && Shopify.theme.id ? `?theme=${Shopify.theme.id}` : '';
    return INVITE_HOST + b64u(myPair()) + th;
  }

  /* ── arriving from a pair link: what they chose and how the two will look together; their sizes, filled ── */
  const PKEY = 'dl.lillo.pair';
  let pair = null;
  try {
    const q = new URLSearchParams(location.search).get('pair');
    if (q) { pair = unb64u(q); sessionStorage.setItem(PKEY, JSON.stringify(pair)); }
    else pair = JSON.parse(sessionStorage.getItem(PKEY) || 'null');
  } catch (e) { pair = null; }
  if (pair && !cfg.rings[pair.k]) pair = null;
  const pairSec = $('[data-dlb-pair]', root);
  if (pair && pairSec) {
    const r = RING(pair.k), nm = (pair.n || '').slice(0, 24);
    if (q2() && st.yours == null && pair.p != null) { st.yours = +pair.p; }
    if (q2() && st.theirs == null && pair.y != null) { st.theirs = +pair.y; st.later = false; }
    st.who = 'two'; st.oh = ''; save();
    $('[data-dlb-pair-img="theirs"]', pairSec).src = r.top; $('[data-dlb-pair-img="mine"]', pairSec).src = cfg.halves.bottom;
    $('[data-dlb-pair-t]', pairSec).textContent = nm ? tt('pair_from', 'From {name}').replace('{name}', nm) : r.title;
    $('[data-dlb-pair-s]', pairSec).textContent = tt('pair_from_note', '{piece}. One half is cut for your hand. Now choose the half you give back: your two sizes are already here.').replace('{piece}', r.title);
    pairSec.hidden = false; root.classList.add('dlb-is-pair');
    try {
      const seenKey = 'dl.lillo.inv.' + JSON.stringify([pair.n, pair.t, pair.k, pair.y, pair.p]).length + (pair.n || '') + (pair.k || '');
      if (q2() && !sessionStorage.getItem(seenKey)) { sessionStorage.setItem(seenKey, '1'); setTimeout(() => openInv(pair, false), 0); }
    } catch (e) {}
  }
  function q2() { return !!new URLSearchParams(location.search).get('pair'); }

  /* ── 14 Oct: the card ("Your LILLO"): the question folds into its first line once the sizes are set ── */
  const flowEl = $('[data-dlb-flow]', root), wholine = $('[data-dlb-wholine]', root), flowhead = $('[data-dlb-flowhead]', root);
  const wSets = $('[data-dlb-wsets]', root) ? makeSets($('[data-dlb-wsets]', root), cfg.halves, RING(cfg.other)) : null;
  if (wSets) { wSets.draw(1); off.push(wSets.loopInView(3000)); }
  const ohSets = $('[data-dlb-ohsets]', root) ? makeSets($('[data-dlb-ohsets]', root), cfg.halves, RING(cfg.other)) : null;
  const wIso = $('[data-dlb-wiso]', root);
  if (wIso && isoImg) { const r = RING(cfg.piece); wIso.addEventListener('error', () => { if (r.photo && wIso.getAttribute('src') !== r.photo) { wIso.classList.add('is-photo'); wIso.src = r.photo; } }, { once: true }); wIso.src = r.iso || r.photo || ''; }
  const szLine = $('[data-dlb-szline]', root);
  if (szLine) szLine.addEventListener('click', openSizesStep);
  if (wholine) wholine.addEventListener('click', () => {
    whoOpen = true; renderFlow();
    requestAnimationFrame(() => whoSec.scrollIntoView({ block: 'nearest', behavior: RM ? 'auto' : 'smooth' }));
  });
  const hLines = $$('[data-dlb-hline]', root);
  hLines.forEach(b => b.addEventListener('click', openStep));
  const dotEl = () => { const d = document.createElement('span'); d.className = 'dlb-dot'; d.textContent = ' · '; return d; };
  function renderFlow() {
    if (!flowReady || !flowEl) return;
    whoSec.hidden = !whoOpen;
    /* option A: the open step (sizes, then names) or one folded line per half */
    const sizesSet = !unset('yours') && !unset('theirs');
    const folded = sizesSet && !editing && !enOpen && enAuto;          // the summary: one line per half
    szSec.hidden = !editing; enSec.hidden = !enOpen;
    if (szLine) {
      szLine.hidden = editing || !sizesSet || folded;
      const k = $('[data-dlb-szk]', szLine); k.textContent = one() ? k.dataset.one : k.dataset.two;
      $('[data-dlb-szv]', szLine).replaceChildren(...(one() ? [show(st.yours)] : [show(st.yours), dotEl(), st.later ? dlT('lillo.to_follow', 'To follow') : show(st.theirs)]));
    }
    const sn = $('[data-dlb-swapnote]', root); if (sn) sn.hidden = one();
    flowhead.hidden = whoOpen;
    hLines.forEach(b => {
      const yours = b.dataset.dlbHline === 'yours';
      b.hidden = !folded || (!yours && one());
      const v = $('[data-dlb-hv]', b), k = $('[data-dlb-hk]', b);
      /* no name on this half: the half itself, never a loupe with the sample name cut in it */
      const hasName = yours ? !!st.e1 : !!(st.e2 || st.e1), hh = $('[data-dlb-hhalf]', b);
      b.classList.toggle('is-plain', !hasName);
      if (hh && !hh.getAttribute('src')) hh.src = cfg.halves[hh.dataset.dlbHhalf];
      if (k) k.textContent = one() ? k.dataset.one : k.dataset.two;
      if (yours) {
        const nm = one() ? [st.e1, st.e2].filter(Boolean).join(', ') : st.e1;
        v.replaceChildren(st.yours != null ? show(st.yours) : '', ...(nm ? [dotEl(), nm] : []));
      } else {
        const nm = st.e2 || st.e1;
        v.replaceChildren(st.later ? dlT('lillo.to_follow', 'To follow') : show(st.theirs), ...(nm ? [dotEl(), nm] : []));
      }
    });
    const szh = $('#dlb-sz-h', szSec);
    if (szh) { if (one()) szh.textContent = szh.dataset.dlbAlt || szh.textContent; else szh.replaceChildren(dlT('lillo.yours', 'Yours'), dotEl(), dlT('lillo.theirs', 'Theirs')); }
    $$('[data-dlb-ring] figcaption > span', root).forEach((sp, i) => { sp.textContent = one() ? sp.dataset.dlbAlt : (i ? dlT('lillo.theirs', 'Theirs') : dlT('lillo.yours', 'Yours')); });
    const wn = $('[data-dlb-whonote]', root);
    if (wn) { wn.hidden = one(); if (!wn.textContent) wn.textContent = (wn.dataset.tpl || '').replace('{price}', RING(cfg.piece).price || '').replace('{price2}', RING(cfg.piece).price2 || ''); }
    wholine.hidden = whoOpen;
    const wv = $('[data-dlb-wval]', wholine); wv.textContent = one() ? wv.dataset.one : wv.dataset.two;
    if (wIso) wIso.hidden = !one(); $('[data-dlb-wsets]', wholine).hidden = one();
    if (wSets) wSets.pics(cfg.halves, RING(st.oh === 'here' ? st.pt : cfg.other));
    flowEl.classList.toggle('is-sizes', editing || unset('yours') || unset('theirs'));   // the names wait, quiet
    renderOh();
  }
  flowReady = true;
  /* 15 Oct: "Invite them to order theirs" in the bag comes back here with ?invite=1 */
  const wantInvite = new URLSearchParams(location.search).get('invite') === '1';
  if (wantInvite && st.oh !== 'here') { st.oh = 'link'; ohOpen = true; }

  /* ── hover to see (13 Oct). Eliau: "should we do, that is enough to hover with the mouse to see the colors and
     styles? without tapping". With a mouse only (a phone has no hover; a tap still chooses). Resting on a style or a
     gold shows that piece in the first picture; leaving puts the page's own back; a click still goes to it. ── */
  const HOVER = matchMedia('(hover: hover) and (pointer: fine)');
  const keyOf = a => { const m = (a.getAttribute('href') || '').match(/lillo-([a-z]+)-ring-([a-z]+)-gold/); return m ? `${m[1]}-${m[2]}` : null; };
  let hovT = 0, hovImg = null, warmed = false;
  function hoverShow(key) {
    const r = cfg.rings[key], w = imagesWrap(); if (!r || !r.featured || !w) return;
    const img = $('img.pdp-hero--main-image', w); if (!img) return;
    if (!hovImg) { hovImg = img; img.dataset.dlbHovSrc = img.getAttribute('src') || ''; img.dataset.dlbHovSet = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset'); img.setAttribute('src', r.featured); img.classList.add('dlb-hovering');
  }
  function hoverEnd() {
    clearTimeout(hovT);
    if (!hovImg) return;
    hovImg.setAttribute('src', hovImg.dataset.dlbHovSrc); if (hovImg.dataset.dlbHovSet) hovImg.setAttribute('srcset', hovImg.dataset.dlbHovSet);
    hovImg.classList.remove('dlb-hovering'); delete hovImg.dataset.dlbHovSrc; delete hovImg.dataset.dlbHovSet; hovImg = null;
  }
  function warm() {                                       // the other pieces' first pictures, fetched once, on the first hover
    if (warmed) return; warmed = true;
    Object.values(cfg.rings).forEach(r => { if (r.featured) { const i = new Image(); i.src = r.featured; } });
  }
  listen(hero, 'pointerover', e => {
    if (!HOVER.matches) return;
    const a = e.target.closest && e.target.closest('a.pdp-variant-selector__pill, a.pdp-variant-selector__swatch'); if (!a) return;
    const k = keyOf(a); if (!k || k === cfg.piece) { clearTimeout(hovT); if (hovImg) hoverEnd(); return; }
    warm(); clearTimeout(hovT); hovT = setTimeout(() => hoverShow(k), 90);
  });
  listen(hero, 'pointerout', e => {
    const a = e.target.closest && e.target.closest('a.pdp-variant-selector__pill, a.pdp-variant-selector__swatch'); if (!a) return;
    const to = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('a.pdp-variant-selector__pill, a.pdp-variant-selector__swatch');
    if (!to) hoverEnd();
  });
  /* the same in "Choose theirs too": resting on a style or a gold shows their half in it; leaving shows the chosen one */
  if (ohSec) {
    listen(ohSec, 'pointerover', e => {
      if (!HOVER.matches || st.oh !== 'here') return;
      const b = e.target.closest && e.target.closest('[data-dlb-oh-sty] button, [data-dlb-oh-gold] button'); if (!b) return;
      const [pt, pg] = st.pt.split('-'), inSty = !!b.closest('[data-dlb-oh-sty]');
      const k = inSty ? `${b.textContent.trim().toLowerCase()}-${pg}` : `${pt}-${(b.className.match(/is-(yellow|rose|white)/) || [])[1]}`;
      const r = cfg.rings[k] || (inSty && GLD.map(g => cfg.rings[`${b.textContent.trim().toLowerCase()}-${g}`]).find(Boolean));
      if (!r) return;
      $('[data-dlb-oh-img="theirs"]', ohSec).src = r.bottom; $('[data-dlb-oh-cap]', ohSec).textContent = `${cfg.title}  ·  ${r.title}`;
    });
    listen(ohSec, 'pointerleave', () => { if (st.oh === 'here') renderOh(); });
    listen(ohSec, 'pointerout', e => {
      if (!e.target.closest || !e.target.closest('[data-dlb-oh-sty] button, [data-dlb-oh-gold] button')) return;
      const to = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-dlb-oh-sty] button, [data-dlb-oh-gold] button');
      if (!to && st.oh === 'here') renderOh();
    });
  }

  /* ── The invitation: what the other person sees first (and the sender can preview) ─────────────────────────────
     Eliau, 13 Oct: "the link need to be more captivating". Night, their name, the words written for them, the two
     pieces doing the exchange (theirs = the piece on this page; for a preview, the other gold), one button. */
  const inv = $('[data-dlb-inv]', root);
  let invSets = null, invPreview = false;
  if (inv) {
    $$('body > [data-dlb-inv]').forEach(n => { if (n !== inv) n.remove(); });
    document.body.appendChild(inv); inv.setAttribute('data-lenis-prevent', '');
    /* the theme's LIGHT logo (for dark pages) is the img.logo-static (mockups CLAUDE.md, trap 4) */
    const logo = $('img.custom-header--logo-image.logo-static', document) || $('img.logo-static', document);
    if (logo) $('[data-dlb-inv-logo]', inv).appendChild(logo.cloneNode(true));
  }
  function openInv(p, preview) {
    if (!inv || !p) return;
    invPreview = !!preview;
    const from = (p.n || '').slice(0, 24), to = (p.t || '').slice(0, 24), note = (p.m || '').slice(0, 140);
    $('[data-dlb-inv-to]', inv).textContent = to ? tt('inv_to', '{name},').replace('{name}', to) : '';
    $('[data-dlb-inv-t]', inv).textContent = from ? tt('inv_made', '{name} made a half for your hand.').replace('{name}', from) : tt('inv_made_anon', 'A half was made for your hand.');
    const q = $('[data-dlb-inv-note]', inv); q.hidden = !note;
    $('[data-dlb-inv-note-t]', inv).textContent = note; $('[data-dlb-inv-note-by]', inv).textContent = from;
    /* whose ring is whose, under the two sets: the sender's name, then yours */
    $('[data-dlb-inv-l1]', inv).textContent = from; $('[data-dlb-inv-l2]', inv).textContent = dlT('lillo.yours', 'Yours');
    /* the sender's piece, and the piece the other person will make (the page's own, or another gold for a preview) */
    const theirs = RING(p.k), mine = preview ? RING(cfg.other) : { top: cfg.halves.top, bottom: cfg.halves.bottom };
    const box = $('[data-dlb-inv-sets]', inv);
    if (!invSets) invSets = makeSets(box, theirs, mine, true); else invSets.pics(theirs, mine);
    inv.hidden = false; inv.classList.remove('is-in'); void inv.offsetWidth; inv.classList.add('is-in');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => { invSets.draw(0); invSets.loop(3200); });
    $('[data-dlb-inv-go]', inv).focus({ preventScroll: true });
  }
  function closeInv(go) {
    if (!inv || inv.hidden) return;
    inv.hidden = true; document.documentElement.style.overflow = ''; if (invSets) invSets.stop();
    if (go && !invPreview) setTimeout(() => (whoSec || szSec).scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }), 60);
  }
  if (inv) {
    $('[data-dlb-inv-go]', inv).addEventListener('click', () => closeInv(true));
    $('[data-dlb-inv-x]', inv).addEventListener('click', () => closeInv(false));
    $('[data-dlb-inv-how]', inv).addEventListener('click', () => { closeInv(false); const o = $('[data-dlb-guide-open]', root); if (o) o.click(); });
    inv.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); closeInv(false); } trap($('.dlb-inv-in', inv), e); });
  }

  /* ── How it works: the mini guide ── */
  const guide = $('[data-dlb-guide]', root);
  let gSets = null;
  if (guide) {
    $$('body > [data-dlb-guide]').forEach(n => { if (n !== guide) n.remove(); });
    document.body.appendChild(guide); guide.setAttribute('data-lenis-prevent', '');
    const arts = $$('[data-dlb-gart]', guide).map(a => { const b = document.createElement('span'); b.className = 'dlb-sets'; a.appendChild(b); return makeSets(b, cfg.halves, RING(cfg.other)); });
    gSets = arts;
    const open = () => {
      guide.hidden = false; document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => { arts[0].draw(0); arts[2].draw(1); arts[1].loop(3000); });
      $('.dlb-x', guide).focus({ preventScroll: true });
    };
    const close = () => { guide.hidden = true; document.documentElement.style.overflow = ''; arts.forEach(a => a.stop()); const o = $('[data-dlb-guide-open]', root); if (o) o.focus({ preventScroll: true }); };
    $$('[data-dlb-guide-open]', root).forEach(b => b.addEventListener('click', open));
    $$('[data-dlb-guide-x]', guide).forEach(x => x.addEventListener('click', close));
    guide.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); close(); } trap($('.dlb-gpanel', guide), e); });
  }

  /* ── layers: Escape closes; Tab stays inside ───────────────────────────────── */
  const focusables = r => $$('button, input:not([disabled]), [tabindex]:not([tabindex="-1"])', r).filter(n => n.offsetParent !== null && !n.closest('[hidden]'));
  function trap(r, e) {
    if (e.key !== 'Tab') return; const f = focusables(r); if (!f.length) return;
    const a = document.activeElement, first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (a === first || !r.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !r.contains(a))) { e.preventDefault(); first.focus(); }
  }
  pop.addEventListener('keydown', e => trap($('[data-dlb-pop-panel]', pop), e));
  sheet.addEventListener('keydown', e => trap(sheet, e));
  listen(document, 'keydown', e => {
    if (e.key !== 'Escape') return;
    if (!pop.hidden) { e.preventDefault(); closeSizes(); } else if (!sheet.hidden) { e.preventDefault(); commitSheet(); }
  });

  let tToast = 0;
  function toast(t) {
    let el = $('body > .dlb-toast'); if (!el) { el = document.createElement('div'); el.className = 'dlb-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = t; el.classList.add('is-on'); clearTimeout(tToast); tToast = setTimeout(() => el.classList.remove('is-on'), 1900);
  }

  /* ── where each block lives: phone (pop-up + sheet) or desktop (on the page) ── */
  let arranged = false;
  function arrange() {
    const d = desk();
    if (!pop.hidden) { pop.hidden = true; pop.classList.remove('is-in'); }
    if (!sheet.hidden) { sheet.hidden = true; kbOpen = false; }
    document.documentElement.style.overflow = '';
    /* Eliau, 20 Sep: "the engraving and the two sizes I think it needs a little bit of help…
       a little box where it shows the engraving… the two sizes like a little bit of the slider."
       So neither hides behind a door any more: both work in the page, on a phone as on a desktop.
       On a phone the full-screen ring is still there, one tap away on the little box. */
    $('[data-dlb-sz-inline]', root).appendChild(sizerEl);
    $('[data-dlb-en-inline]', root).appendChild(fieldsEl); $('[data-dlb-en-inline]', root).hidden = false;
    /* the first question goes first: one name or two, then the two rings, then the field (Eliau, 11 Oct) */
    const cnt = $('.dlb-count', root), rg = $('[data-dlb-rings]', root);
    if (cnt && rg && cnt.nextElementSibling !== rg) rg.parentNode.insertBefore(cnt, rg);
    if (d) {
      live.prepend(camEl); camEl.classList.remove('is-none'); camNone.hidden = true;
      fullEl.crossOrigin = 'anonymous'; fullEl.src = cfg.plates[cfg.gold].full;
    } else {
      sheet.insertBefore(camEl, bar);
    }
    if (!arranged) {
      arranged = true;
      /* 14 Oct, Eliau: "keep you each wear one preselected". So the first question is already answered and the sizes
         open first; arriving with both sizes (a pair link, a return visit) the names open instead. */
      const sizesSet = !unset('yours') && !unset('theirs');
      /* 15 Oct (4), Eliau: "the done at first step is too much and not needed". First visit = the question (the
         exchange preselected) with the sizes open under it; the sizes' Done folds both. Arriving with both sizes (a pair
         link, a return) the names open; with names too, the summary */
      editing = !sizesSet; foldArmed = false; whoOpen = !sizesSet;
      if (sizesSet && !st.e1) { enOpen = true; enAuto = true; }
      if (sizesSet && st.e1) enAuto = true;
    }
    syncFields(); renderRow(); renderSizer(); renderEn(); renderGallery(); renderWho();
    requestAnimationFrame(() => { place('yours', false); place('theirs', false); applyCam(); });
  }
  listen(DESK, 'change', arrange);
  listen(window, 'resize', () => { place('yours', false); place('theirs', false); applyCam(); });

  pushSizes(); pushEngraving(); save();
  arrange();
  if (wantInvite) requestAnimationFrame(() => { if (ohSec && !ohSec.hidden) ohSec.scrollIntoView({ block: 'center', behavior: 'auto' }); });
  /* A name is required, so nearly every buyer types one: fetch the engraving picture and its data
     while the page is idle, and the first letter appears on the ring the moment it is typed. */
  if (!cfg.hasPlate) root.classList.add('dlb-nolp');      // no engraving picture for this piece: the row is words only
  if (cfg.hasPlate) (window.requestIdleCallback || (f => setTimeout(f, 1200)))(() => {
    ensureCutters(); ensureFront();
    ensureRings().then(ok => { if (ok) { ringsUpdate(); ringsDraw(); turnIntro(); } else root.classList.add('dlb-nolp'); });
    if (!fullEl.getAttribute('src')) { fullEl.crossOrigin = 'anonymous'; fullEl.src = cfg.plates[cfg.gold].full; }
  }, { timeout: 3000 });

  return {
    root,
    flag(kind, slot) {
      /* Add to Bag found something missing. If this page already holds it, the theme's field
         simply missed it: push it and send the tap on, so the buyer's tap is never lost. */
      const again = () => setTimeout(() => { const a = $('[data-add-to-cart]', hero); if (a && !a.disabled) a.click(); }, 0);
      if (kind === 'size') {
        pushSizes();
        if (legacyReady()) { again(); return true; }
        openSizes(slot === 'theirs' ? 'theirs' : 'yours', true); return true;
      }
      if (kind === 'engraving') {
        pushEngraving();
        if (st.e1 && legacyEng && legacyEng.value.trim()) { again(); return true; }
        enSec.classList.add('is-flag'); openEngrave(false); return true;
      }
      return false;
    },
    who() { return st.who; },
    /* the partner's ring, when "Choose theirs too" is on. Its two halves are cut in the SAME two sizes as yours (one for
       your hand, one for theirs); what differs is the style and the gold. Eliau, 13 Oct: "whats the point to ask for the
       engraving here if anyway is right under this step?" So its names come from the one Engraving step. The story is
       "each ring carries both your names" (30 Sep): your order cuts your name on your half and theirs on theirs, so
       their order cuts the opposite (their name on the half for YOUR hand, yours on the half for theirs), and each
       finger ends with both names. The line reads from your side, like its sizes: 'yours' = your hand.
       sz = the two size values the order already carries. */
    extraItems(sz) {
      if (one() || st.oh !== 'here') return [];
      const r = cfg.rings[st.pt]; if (!r) return [];
      const a = (st.e1 || '').slice(0, 32), b = st.two ? (st.e2 || '').slice(0, 32) : '';
      const p = { 'Size · yours': sz.yours, 'Size · theirs': sz.theirs, 'Wears it': 'The exchange · their ring' };
      if (a && b) Object.assign(p, { 'Engraved name': b, 'Second engraving': a, 'Engraving': b + ' on your ring, ' + a + ' on their ring' });
      else if (a) Object.assign(p, { 'Engraved name': a, 'Engraving': a + ' on both rings' });
      p['Pair with'] = enTitle(cfg.piece);
      return [{ id: r.variant, quantity: 1, properties: p }];
    },
    pairWith() { return pair ? [(pair.n || '').slice(0, 24), enTitle(pair.k)].filter(Boolean).join(', ') : ''; },
    state() {
      const img = findFront();
      return { tier: cfg.tier, gold: cfg.gold, data: String(cfg.engraveData).split('/').pop().split('?')[0],
        cx: D && D.cx, cy: D && D.cy, crop2: D && D.crop2, front: img ? (img.dataset.dlbAlt || img.alt) : null,
        engraved: !!(img && img.dataset.dlbSrc), liveFirst: !!(imagesWrap() && imagesWrap().firstElementChild === live) };
    },
    destroy() {
      hoverEnd();
      off.forEach(f => f()); pop.remove(); sheet.remove(); live.remove(); if (guide) guide.remove(); if (inv) inv.remove();
      if (tileSets) tileSets.stop(); if (gSets) gSets.forEach(a => a.stop());
      if (frontURL) { URL.revokeObjectURL(frontURL); frontURL = null; }
      document.documentElement.style.overflow = '';
    },
  };
}
})();
